import {AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ApiService} from "../../../services/main/api.service";
import {NgbActiveModal, NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {Storage} from "@ionic/storage";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {BaseCrudComponent} from "../../base-crud/base-crud.component";
import {environment} from "../../../../environments/environment";
import Swal from "sweetalert2";
import {isNumeric} from "rxjs/util/isNumeric";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {NoOnlyWhitespaceDirective} from "../../../no-only-whitespace.directive";
import {noWhitespaceValidator} from "../../../no-whitespace.validator";
import {Workbook} from "exceljs";
import {Alignment, BorderStyle, Fill, Font, Cell} from "exceljs/index";
import * as fs from "file-saver";
import {Param, CellConfig} from "../../../interfaces/dataformart";
import QRCode from 'qrcode';

const API_GET_PARAM_TOOLTIP = environment.Global.API_GET_PARAMTOOLTIP;
const API_GET_ENTRY_DATA = environment.Global.API_GET_ENTRYDATA;
const API_PARAM_RISK_MATRIX_ALL = environment.Global.API_GET_PARAMRISKMATRIX_ALL;
const API_GETALLDATA = environment.Global.API_GET_ALLDATA;
const API_GETDATABYCOMPANY = environment.Global.API_GET_DATA_BY_COMPANY;
const API_GETDATABYUSERGISIS = environment.Global.API_GET_DATA_BY_USERGISIS;
const API_CONSULTACOMPANIES = environment.API_CONSULTACOMPANIES;
const API_CONSULTAAREAS = environment.Global.API_GET_ALLAREA;
const API_CREATETASKRISKANALYSIS = environment.Global.API_POST_CREATE_TASKRISKA;
const API_UPDATETASKRISKANALYSIS = environment.Global.API_POST_UPDATE_TASKRISKA;
const API_DELETETASKRISKANALYSIS = environment.Global.API_POST_DELETE_TASKRISKA;
const API_SENDMAIL_TASKRISKANALYSIS = environment.Global.API_POST_SENDMAIL_TASKRISKA;
const API_POST_SENDMAIL_TASKRISKAPPROVED = environment.Global.API_POST_SENDMAIL_TASKRISKAPPROVED;
const GET_ALL_SITES_ACTIVE = environment.Global.API_GET_ALL_SITES_ACTIVE;
const GET_ALL_AREA_BY_ID = environment.Global.API_GET_ALL_AREA_BY_ID;
const API_USER_APPROVERS_GET_ALL = environment.Global.API_USER_APPROVERS_GET_ALL;
const API_USER_APPROVERS_GET__BY_PLANT = environment.Global.API_USER_APPROVERS_GET__BY_PLANT;
const API_POST_APPROVE_OR_REJECT = environment.Global.API_POST_APPROVE_OR_REJECT;
const API_GET_EMPLOYEE_BY_COMPANY = environment.Global.API_GET_EMPLOYEE_BY_COMPANY;
const API_USER_GISIS_GET_ALL = environment.Global.API_USER_GISIS_GET_ALL;
@Component({
  selector: 'app-form-art',
  templateUrl: './form-art.component.html',
  styleUrls: ['./form-art.component.css']
})
export class FormARTComponent extends BaseCrudComponent implements OnInit{
  selected_id = false;
  // paramList = [];
  index:number;
  emergency_checked = false;
  loadingList = false;
  userinfo:any;
  UserId:any;
  currentPlanta:any;
  row_company:any;
  row_plantas:any;
  row_employee:any;
  row_userGisis:any;
  list_pprovers:any;
  countApprovers
  row_plantas_area:any;
  mostarselectemp;
  viewData = false;
  isUpdating = false;
  editItem = false;
  loadingRequired = false;
  row_risk:any;
  isSkretting = false;
  isApproved = false;
  isGisisApproved = false;
  isDone=false;
  IdCompany:any;
  signatureGisis="";
  signatureApprover="";
  signatureCompany="";
  diffDate;
  listaparamid = [];
  row_emp:any; // lista que obtiene los trabajadores
  entryList = [];
  selectObj = [];
  pageTotal2 = 0;
  page2 = 0;
  // stepbystep : string;
  // tools : string;
  // associatedrisk : string;
  // riskwithout : string;
  // applicablecontrol : string;
  // epps : string;
  // applicablerisk : string;
  // ptsrequired : string;
  workOrders: any[] = [];
  backColor: any;
  tooltipMsg: any;
  list_process = [{title: 'job_order', id: 1}, {title: 'purchase_Order', id: 2}, {title: 'capex_Order', id: 3} ]
  option_processes:any;
  disable_wo = false;
  selectState: { [key: string]: { color: string; tooltip: string; val: number, desc: string} } = {};
  private riskMatrix: { [key: string]: number } = {};

  paramList: Param[] = [];
  stepbystep: any;
  tools: any;
  associatedrisk: any;
  riskwithout: any;
  applicablecontrol: any;
  epps: any;
  applicablerisk: any;
  ptsrequired: any;

  archivos: any;
  namefile: any;
  mensaje = "";
  size_max = 3145728;//3mb
  cargavacia = false;
  cargados = false;
  alertMsj: any

  @ViewChild('create1', { static: false }) create1!: TemplateRef<any>;
  @ViewChild('create2', { static: false }) create2!: TemplateRef<any>;
  @ViewChild('reason', { static: false }) reason!: TemplateRef<any>;

  modal1Ref!: NgbModalRef;
  modal2Ref!: NgbModalRef;
  modal3Ref!: NgbModalRef;

  constructor(
    srv: ApiService,
    modalService: NgbModal,
    storage: Storage,
    router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private formBuilder: FormBuilder
  ) {
    super(srv, modalService, storage, router);
  }

  async ngOnInit() {
    await this.translate.getTranslation(this.translate.currentLang)
      .toPromise().then((translations) => {
        this.translations = translations;
        super.ngOnInit();
      });
    this.pageSize = 10;
    this.pageSize2 = 10;
    this.search_fields = ['EntryRequestId','Requiredby'];
    this.userinfo = [];
    this.userinfo['name'] = '';
    this.userinfo['emailAddress'] = '';
    await this.storage.get('userinfo').then(async x => {
      this.userinfo = x;
      if (isNumeric(this.userinfo.logon)) {
        this.mostarselectemp = false;
        this.isSkretting = false;
      } else {
        this.isSkretting = true;
      }
      await this.storage.get('currentPlanta').then(planta => {
        this.currentPlanta = planta;
      });
      await this.getApprovers(this.currentPlanta);
      this.getList();
      this.getParamToolTip();
      this.getlistParamRisk();
      await this.GetEmployee();
      this.GetUserGisis();
    });
  }
  getProgressType(approvers: string): string {
    const [actual, total] = approvers.split('-').map(Number);

    if (actual === 3 && total === 3) return 'success'; // verde
    if (actual === 2 && total === 3) return 'warning'; // naranja
    return 'danger'; // rojo por defecto
  }
  public GetEmployee(): Promise<void> {
    return new Promise((resolve, reject) => {
      let qst = this.isSkretting
        ? API_GET_EMPLOYEE_BY_COMPANY + this.c_obj['CompanyId']
        : API_GET_EMPLOYEE_BY_COMPANY + this.userinfo.selectedCompanyId;

      this.srv.getCall(qst).subscribe({
        next: (x) => {
          if (x.success && x.val != null) {
            this.row_employee = x.val;
            console.log('Employee List:', this.row_employee);
            resolve(); // ✅ Ya está cargado
          } else {
            this.row_employee = [];
            resolve(); // igual resolvemos, aunque vacío
          }
        },
        error: (err) => {
          console.error('Error en GetEmployee:', err);
          reject(err); // ❌ por si necesitas manejar errores
        },
      });
    });
  }
  public GetEmployeeold() {
    if(this.isSkretting){
    var qst = API_GET_EMPLOYEE_BY_COMPANY + this.c_obj['CompanyId'];
    }
    else {
    var qst = API_GET_EMPLOYEE_BY_COMPANY + this.userinfo.selectedCompanyId;
    }
    this.srv.getCall(qst).subscribe(x => {
      if(x.success){
        if(x.val != null){
          var rs = x.val;
          this.row_employee = rs;
          console.log('Employee List:', this.row_employee);
        }else {
          this.row_employee = [];
          return;
        }
      }else {
        return;
      }
    });
  }

  public GetUserGisis() {
    var qst = API_USER_GISIS_GET_ALL;
    this.srv.getCall(qst).subscribe(x => {
      if(x.success){
        if(x.val != null){
          var rs = x.val;
          this.row_userGisis = rs;
        }else {
          this.row_userGisis = [];
          return;
        }
      }else {
        return;
      }
    });
  }

  Aprobar(form:any){
    this.isCreating = true;
    const detalles = form['TaskAnalysisDetails'];
    const tieneRechazados = detalles.some((item: any) => item.RowStatus === true);
    if (tieneRechazados) {
      Swal.fire({
        icon: 'warning',
        title: 'No se puede aprobar',
        text: 'Existen items marcados como rechazados. Debe resolverlos antes de aprobar.',
      });
      return; // Detiene la ejecución
    }

    var qst = API_POST_APPROVE_OR_REJECT;
    let newForm : any;
    newForm = [];
    newForm = {
      UserId: this.UserId !== undefined ? this.UserId : form.GISIS,
      TaskRiskAnalysisId: form['TaskRiskAnalysisId'],
      Approve: true,
    };
    console.log(newForm);
    debugger;
    this.srv.postCall(qst,newForm).subscribe(x => {
      if(x.success){
        debugger
        if(x.val != null){
        this.row_risk = x.val;

        let approvers = this.row_risk.TaskRiskAnalysis.Approvers;
          if (approvers && approvers.split('-')[0] === approvers.split('-')[1]) {
            this.sendMailARTApproved(this.row_risk);
          }
          Swal.fire(this.translations.approve_art, `${this.translations.menu_reportapproval} - ${this.translations.msg_notify_approve}`, 'success');
          this.isCreating = false;
          this.modal1Ref.close();
          this.getList();
        }else {
          Swal.fire(this.translations.approve_art, x.msg ||this.translations.menu_reportapproval, 'warning');
          this.modal1Ref.close();
          return;
        }
      }
      else {
        Swal.fire(this.translations.approve_art, x.msg , 'error');
        this.row_risk = [];
        this.isCreating = false;
        return;
      }
    });
  }

  Rechazar(form:any){
    this.isCreating = true;
    console.log('Rechazar', form);
    var qst = API_POST_APPROVE_OR_REJECT;
    let newForm : any;
    newForm = [];
    newForm = {
      UserId: this.UserId !== undefined ? this.UserId : form.GISIS,
      TaskRiskAnalysisId: form['TaskRiskAnalysisId'],
      Approve: false,
      Comentary: this.c_obj['observacion']
    };
    console.log(newForm);
    debugger;
    this.srv.postCall(qst,newForm).subscribe(x => {
      if(x.success){
        if(x.val != null){
          // this.sendMailART(this.row_risk)
          this.isCreating = false;
          Swal.fire(this.translations.reject, this.translations.rejected, 'success');
          this.modal3Ref.close();
          this.modal1Ref.close();
          this.updateART(form, false); // Se guarda el cambio sin enviar a aprobación
          this.getList();
        }else {
          Swal.fire(this.translations.reject, x.msg ||this.translations.rejected, 'warning');
          this.modal3Ref.close();
          return;
        }
      }else {
        this.isCreating = false;
        Swal.fire(this.translations.reject, x.msg, 'error');
        return;
      }
    });
  }

  public getList(){
    var qst = "" ;
    this.loadingList = true;

    if(isNumeric(this.userinfo.logon) )
    {
      // qst = GET_ALL_REQUEST_BY_COMPANY_ID + this.userinfo.selectedCompanyId;
      qst = API_GETDATABYCOMPANY + this.userinfo.selectedCompanyId;
    }else if(this.currentPlanta == null){
      qst = API_GETDATABYUSERGISIS + this.userinfo.userId;
    }
    else{
      qst = API_GETALLDATA;
    }
    Swal.fire(
      {
        title: this.translations['loading'],
        html: '',
        icon: 'info',
      }
    );
    Swal.showLoading();
    this.srv.getCall(qst).subscribe(x => {
      if(x.success){
        if(x.val != null){
          this.rawdata = x.val;
          this.rows = x.val;
          this.page = 1;
          if( Array.isArray(this.rows) ){
            this.pageTotal = this.rows.length;
          }
          this.loadingList = false;
          this.filterAll();
          Swal.close()
        }else {
          Swal.fire(this.translations.empty, this.translations.not_registers, 'warning');
          this.rows = [];
          return;
        }
      }else {
        this.loadingList = false;
        Swal.fire(x.msg, '', 'error');
        return;
      }
    });
  }

  public async getApprovers(idPlanta:any) {
    var qst = "" ;
    if(this.currentPlanta!=null) {
      qst = `${API_USER_APPROVERS_GET__BY_PLANT}/${idPlanta}`;//Obtener aprobadores por planta
    }else if(isNumeric(this.userinfo.logon)){
      qst = `${API_USER_APPROVERS_GET__BY_PLANT}/${idPlanta}`;//Obtener aprobadores por planta en modo  Compañia
    }else{
      qst = API_USER_APPROVERS_GET_ALL;// Obtener todos los aprobadores en modo GISIS
    }
      const response = await this.srv.getCall(qst).toPromise();
      if (response && response.success) {
        // Handle successful response
        if (response.val != null) {
          this.list_pprovers = response.val;
          this.countApprovers = response.val.length;
          const aprobador = this.list_pprovers.find(apr => apr.UserId === this.c_obj.ApprovedHSE);
          this.signatureApprover = (aprobador && aprobador.signature) ? aprobador.signature : null;
          console.log('Lista de aprobadores:', this.list_pprovers);
          const userIdLogged = parseInt(this.userinfo.userId);
          this.isApproved = this.list_pprovers.some(
            ap => {
              if (ap.UserIdAquasym === userIdLogged && ap.PlantaId === Number(this.currentPlanta)) {
                this.UserId = ap.UserId;
                this.signatureApprover = ap.signature;
                return true;
              }
              return false;
            }
          );
        } else {
          this.list_pprovers = [];
        }
      } else {
        this.list_pprovers = [];
      }

      console.log('aprovador', this.isApproved);
      console.log('userid', this.UserId);
      console.log('countApprovers', this.countApprovers);
      // console.log('FIRMA APROBADOR', this.signatureApprover);

  }
  public async getApproversOLD(idPlanta:any) {
    var qst = "" ;
    if(this.currentPlanta!=null) {
      qst = `${API_USER_APPROVERS_GET__BY_PLANT}/${idPlanta}`;//Obtener aprobadores por planta
    }else if(isNumeric(this.userinfo.logon)){
      qst = `${API_USER_APPROVERS_GET__BY_PLANT}/${idPlanta}`;//Obtener aprobadores por planta en modo  Compañia
    }else{
      qst = API_USER_APPROVERS_GET_ALL;// Obtener todos los aprobadores en modo GISIS
    }
    await this.srv.getCall(qst).subscribe(x => {
      if (x.success) {
        if (x.val != null) {
          this.list_pprovers = x.val;
          this.countApprovers=x.val.length;
          if(this.countApprovers==1){
            this.signatureApprover= this.list_pprovers[0].signature;
          }

          console.log('Lista de aprobadores:', this.list_pprovers);

          const userIdLogged = parseInt(this.userinfo.userId);
          this.isApproved = this.list_pprovers.some(
            ap => {
              if (ap.UserIdAquasym === userIdLogged && ap.PlantaId === Number(this.currentPlanta)) {
                this.UserId = ap.UserId;
                this.signatureApprover= ap.signature;
                return true;
              }
              return false;
            }
          );
        } else {
          this.list_pprovers = [];
        }
      } else {
        this.list_pprovers = [];
      }
      console.log('aprovador', this.isApproved)
      console.log('userid', this.UserId)
      console.log('countApprovers', this.countApprovers)
      console.log('FIRMA APROBADOR', this.signatureApprover)
    });
  }
  public createART(form: any, send: boolean){
    this.isCreating = true;
    var validated = true;
    const qst = API_CREATETASKRISKANALYSIS;
    debugger;
    if( form == undefined ){
      form = {};
    }

    if(this.option_processes != null ||this.option_processes != undefined ){
      switch (this.option_processes != 1){
        case true:
          if(form['Order'] == null || form['Order'] == "" || form['Order'] == undefined){
            this.isCreating = false;
            Swal.fire(this.translations['msg_option_order'], '', 'error');
            return;
          }else if(form['SeccionPlantaId'] == null || form['SeccionPlantaId'] == undefined){
            this.isCreating = false;
            Swal.fire(this.translations['msg_option_requiered'], '', 'error');
            return;
          }
          break;
        case false:
          if(form['WorkOrder'] == null || form['WorkOrder'] == undefined){
            this.isCreating = false;
            Swal.fire(this.translations['msg_option_workorder'], '', 'error');
            return;
          }
          break;
      }
    }else{
      this.isCreating = false;
      Swal.fire(this.translations['msg_option_requiered'], '', 'error');
      return;
    }

    validated = this.validateCreateART(form);
    if( !validated ){
      this.isCreating = false;
      Swal.fire(this.translations['msg_all_required'], '', 'error');
      return;
    }

    if (form['TaskAnalysisDetails'].length == 0 && send == true) {
      this.isCreating = false;
      return Swal.fire(this.translations.error, this.translations.msg_rows_analusis_required,'error');
    }
    console.log(form);

    let arrayTaskRisk = [];
    for(let task of form['TaskAnalysisDetails']){
      let taskRisk= {
        StepByStep : task['StepByStep'],
        ToolsEquipmentRequired : task['ToolsEquipmentRequired'],
        EPPs : task['EPPs'],
        RequiredPTS : task['RequiredPTS'],
        RiskDetails : task['RiskDetails'],
      }
      arrayTaskRisk.push(taskRisk);
    }

    let newForm : any;
    newForm = [];
      newForm = {
        TypeOrder: parseInt(this.option_processes),
        DescriptionOrder: this.option_processes == 1 ? null : form['WorkDescription'],
        DocumentOwner: form['DocumentOwner'],
        SecurityCompany: form['SecurityCompany'],
        SubArea: form['SubArea'],
        GISIS: form['GISIS'],
        AssignedDate: form['AssignedDate'],
        EntryRequestId: this.option_processes == 1 ? parseInt(form['WorkOrder']) : null,
        CreateUser: this.userinfo.name,
        CompanyId: this.userinfo.userId,
        PlantaId: this.option_processes == 1 ? form['PlantaId'] : parseInt(form['PlantaId']),
        SeccionPlantaId: this.option_processes == 1 ? null : parseInt(form['SeccionPlantaId']),
        Order: this.option_processes == 1 ? null : form['Order'],
        SendApprove: send,
        Approvers: "1-" + (this.countApprovers + 1 + (form['GISIS'] ? 1 : 0)),
        TaskRiskAnalysisDetails: arrayTaskRisk,
      }
    console.log(newForm);
    debugger;

    this.srv.postCall(qst, newForm).subscribe(      (resp)=>{
        this.row_risk = resp.val;
        if(resp.success){
          if(send == true){
            console.log('Enviar Correo para aprobacion');
            this.sendMailART(this.row_risk)
            Swal.fire(this.translations.msg_create, this.translations.msg_notify_approve, 'success');
          }else{
            Swal.fire(this.translations.msg_create, this.translations.msg_save_art, 'success');
          }
          this.modal1Ref.close();
          this.getList();
          this.isCreating = false;
        }
        console.log(this.row_risk)
        this.isCreating = false;
      },
      (err)=>{
        Swal.fire(this.translations.empty, this.translations.not_registers, 'error');
        this.row_risk = [];
        return;
      }
    )

  }

  toggleReject(task: any, form: any): void {
    console.log('RowStatus', task.RowStatus);
  }

  public updateART(form: any, send: boolean){
    debugger
    console.log('updateART', form, send);
    debugger
    var validated = true;
    const qst = API_UPDATETASKRISKANALYSIS;
    debugger;
    if( form == undefined ){
      form = {};
    }

    if(this.option_processes != null ||this.option_processes != undefined ){
      switch (this.option_processes != 1){
        case true:
          if(form['Order'] == null || form['Order'] == "" || form['Order'] == undefined){
            this.isCreating = false;
            Swal.fire(this.translations['msg_option_order'], '', 'error');
            return;
          }else if(form['SeccionPlantaId'] == null || form['SeccionPlantaId'] == undefined){
            this.isCreating = false;
            Swal.fire(this.translations['msg_option_requiered'], '', 'error');
            return;
          }
          break;
        case false:
          if(form['WorkOrder'] == null || form['WorkOrder'] == undefined){
            this.isCreating = false;
            Swal.fire(this.translations['msg_option_workorder'], '', 'error');
            return;
          }
          break;
      }
    }else{
      this.isCreating = false;
      Swal.fire(this.translations['msg_option_requiered'], '', 'error');
      return;
    }

    validated = this.validateCreateART(form);
    if( !validated ){
      this.isCreating = false;
      Swal.fire(this.translations['msg_all_required'], '', 'error');
      return;
    }

    if (form['TaskAnalysisDetails'].length == 0 && send == true) {
      this.isCreating = false;
      return Swal.fire(this.translations.error, this.translations.msg_rows_analusis_required,'error');
    }
    console.log(form);

    let arrayTaskRisk = [];
    for(let task of form['TaskAnalysisDetails']){
      let taskRisk= {
        StepByStep : task['StepByStep'],
        ToolsEquipmentRequired : task['ToolsEquipmentRequired'],
        EPPs : task['EPPs'],
        RequiredPTS : task['RequiredPTS'],
        // RowStatus: task['RowStatus'],
        RowStatus: send ? false : task['RowStatus'],
        RiskDetails : task['RiskDetails'],
        //AQUI AÑADIR NUEVO ESTADO SI FUE MODIFICADO SINO MANDAR EL QUE ESTABA
      }
      arrayTaskRisk.push(taskRisk);
    }

    let newForm : any;
    newForm = [];
    newForm = {
      TypeOrder: parseInt(this.option_processes),
      TaskRiskAnalysisId: form['TaskRiskAnalysisId'],
      DescriptionOrder: this.option_processes == 1 ? null : form['WorkDescription'],
      DocumentOwner: form['DocumentOwner'],
      SecurityCompany: form['SecurityCompany'],
      SubArea: form['SubArea'],
      GISIS: form['GISIS'],
      AssignedDate: form['AssignedDate'],
      EntryRequestId: this.option_processes == 1 ? parseInt(form['EntryRequestId']) : null,
      LastModifierUser: this.userinfo.name,
      // CompanyId: this.userinfo.userId,
      PlantaId: this.option_processes == 1 ? form['PlantaId']  : parseInt(form['PlantaId']),
      SeccionPlantaId: this.option_processes == 1 ? null : parseInt(form['SeccionPlantaId']),
      Order: this.option_processes == 1 ? null : form['Order'],
      SendApprove: send,
      Approvers: form['Approvers'],
      TaskRiskAnalysisDetails: arrayTaskRisk,
    }
    console.log(newForm);
    debugger;

    this.srv.postCall(qst, newForm).subscribe(
      (resp)=>{
        this.row_risk = resp.val; debugger;
        if(resp.success){
          if(send == true){
            console.log('Enviar Correo para aprobacion');
            this.sendMailART(this.row_risk)
            Swal.fire(this.translations.msg_create, this.translations.msg_notify_approve, 'success');
          }else{
            Swal.fire(this.translations.msg_create, this.translations.msg_save_art, 'success');
          }
          this.modal1Ref.close();
          this.getList();
          this.isCreating = false;
        }
        console.log(this.row_risk)
      },
      (err)=>{
        Swal.fire(this.translations.empty, this.translations.not_registers, 'error');
        this.row_risk = [];
        return;
      }
    )
  }

  public AddItem(form: any){
    var validated = true;
    if( form == undefined ){
      form = {};
    }

    validated = this.validateCreateInfo(form);
    if( !validated ){
      this.isCreating = false;
      Swal.fire(this.translations['msg_all_required'], '', 'error');
      return;
    }

    if (this.row_obj['RiskDetails'].length == 0) {
      this.isCreating = false;
      return Swal.fire(this.translations.error, this.translations.msg_rows_analusis_required,'error');
    }

    let arrayRiskDetails = [];
    for (let obj of form['RiskDetails']) {
      let riskDetails = {
        AssociatedRisk: obj['AssociatedRisk'],
        NotApplicableRiskPR: obj['NotApplicableRiskPR'],
        NotApplicableRiskSV: obj['NotApplicableRiskSV'],
        NotApplicableRiskPRSV: obj['NotApplicableRiskPRSV'],
        ApplicableControls: obj['ApplicableControls'],
        ApplyingRiskPR: obj['ApplyingRiskPR'],
        ApplyingRiskSV: obj['ApplyingRiskSV'],
        ApplyingRiskPRSV: obj['ApplyingRiskPRSV']
      }
      arrayRiskDetails.push(riskDetails);
    }

    if (this.c_obj['TaskAnalysisDetails'].length === 0) {
      this.c_obj['TaskAnalysisDetails'].push(
        {
          StepByStep: form['StepByStep'],
          ToolsEquipmentRequired: form['ToolsEquipmentRequired'],
          EPPs: form['EPPs'],
          RequiredPTS: form['RequiredPTS'],
          RiskDetails: arrayRiskDetails,
        }
      );
      console.log(this.c_obj['TaskAnalysisDetails']);
      this.modal2Ref.close();
    } else {
      let count = 0;
      let typeEmergency = '';
      if (count > 0) {
        this.row_obj['StepByStep'] = '';
        this.row_obj['ToolsEquipmentRequired'] = '';
        this.row_obj['EPPs'] = '';
        this.row_obj['RequiredPTS'] = '';
        this.row_obj['RiskDetails'] = []
        return Swal.fire(
          this.translations.error_creation_proadd,
          this.translations.cant_create_distinct_pro_add,
          'error');
      } else {
        this.c_obj['TaskAnalysisDetails'].push(
          {
            StepByStep: form['StepByStep'],
            ToolsEquipmentRequired: form['ToolsEquipmentRequired'],
            EPPs: form['EPPs'],
            RequiredPTS: form['RequiredPTS'],
            RiskDetails: arrayRiskDetails,
          }
        );
        console.log(this.c_obj['TaskAnalysisDetails']);
        this.modal2Ref.close();
      }
    }
  }

  public updateItem(form: any) {
    let validated = true;
    debugger;

    if (!form) {
      form = {};
    }

    validated = this.validateCreateInfo(form);
    if (!validated) {
      this.isCreating = false;
      Swal.fire(this.translations['msg_all_required'], '', 'error');
      return;
    }

    if (!this.row_obj['RiskDetails'] || this.row_obj['RiskDetails'].length === 0) {
      this.isCreating = false;
      return Swal.fire(this.translations.error, this.translations.msg_rows_analusis_required, 'error');
    }

    let arrayRiskDetails = [];
    for (let obj of form['RiskDetails']) {
      let riskDetails = {
        AssociatedRisk: obj['AssociatedRisk'],
        NotApplicableRiskPR: obj['NotApplicableRiskPR'],
        NotApplicableRiskSV: obj['NotApplicableRiskSV'],
        NotApplicableRiskPRSV: obj['NotApplicableRiskPRSV'],
        ApplicableControls: obj['ApplicableControls'],
        ApplyingRiskPR: obj['ApplyingRiskPR'],
        ApplyingRiskSV: obj['ApplyingRiskSV'],
        ApplyingRiskPRSV: obj['ApplyingRiskPRSV']
      };
      arrayRiskDetails.push(riskDetails);
    }

    // if (!this.c_obj['TaskAnalysisDetails'] || this.c_obj['TaskAnalysisDetails'].length) {
    //   return Swal.fire(this.translations.error, this.translations.invalid_index_or_item, 'error');
    // }

    if(this.index != undefined || this.index != null){
    // Actualizamos el ítem en la posición indicada
      this.c_obj['TaskAnalysisDetails'][this.index]= {
        StepByStep: form['StepByStep'],
        ToolsEquipmentRequired: form['ToolsEquipmentRequired'],
        EPPs: form['EPPs'],
        RequiredPTS: form['RequiredPTS'],
        RiskDetails: arrayRiskDetails,
      };
    }else{
      this.c_obj['TaskAnalysisDetails'].push(
        {
          StepByStep: form['StepByStep'],
          ToolsEquipmentRequired: form['ToolsEquipmentRequired'],
          EPPs: form['EPPs'],
          RequiredPTS: form['RequiredPTS'],
          RiskDetails: arrayRiskDetails,
        }
      );
    }
    this.editItem = false;
    this.index = null;
    console.log('Updated TaskAnalysisDetails:', this.c_obj['TaskAnalysisDetails']);
    this.modal2Ref.close();
  }

  public validateCreateART(fields: any){
    let myart: any = {};
    myart = new FormGroup({
      'WorkDescription' : new FormControl(fields.WorkDescription , [Validators.required, noWhitespaceValidator()]),
      'securitycompany' : new FormControl(fields.SecurityCompany , [Validators.required]),
      'subarea' : new FormControl(fields.SubArea , [Validators.required, noWhitespaceValidator()]),
      'gisis' : new FormControl(fields.GISIS , [Validators.required]),
      'assigneddate' : new FormControl(fields.AssignedDate , [Validators.required, noWhitespaceValidator()]),
    });
    return myart.valid;
  }

  public validateCreateInfo(fields: any){
    let mygroup: any = {};
    mygroup = new FormGroup({
      'StepByStep' : new FormControl(fields.StepByStep , [Validators.required, noWhitespaceValidator()]),
      'ToolsEquipmentRequired' : new FormControl(fields.ToolsEquipmentRequired , [Validators.required, noWhitespaceValidator()]),
      'EPPs' : new FormControl(fields.EPPs , [Validators.required, noWhitespaceValidator()]),
      // 'RequiredPTS' : new FormControl(fields.RequiredPTS , [Validators.required, noWhitespaceValidator()]),
    });
    return mygroup.valid;
  }

  public validateRiskDetail(fields: any, clear: any){
    let riskD: FormGroup;
      riskD = new FormGroup({
        'AssociatedRisk' : new FormControl(fields.AssociatedRisk , [Validators.required, noWhitespaceValidator()]),
        'ApplicableControls' : new FormControl(fields.ApplicableControls , [Validators.required, noWhitespaceValidator()]),
        'NotApplicableRiskPR': new FormControl(fields.NotApplicableRiskPR, [Validators.required]),
        'NotApplicableRiskSV': new FormControl(fields.NotApplicableRiskSV, [Validators.required]),
        'NotApplicableRiskPRSV': new FormControl(this.row_obj.NotApplicableRiskPRSV, [Validators.required]),
        'ApplyingRiskPR': new FormControl(fields.ApplyingRiskPR, [Validators.required]),
        'ApplyingRiskSV': new FormControl(fields.ApplyingRiskSV, [Validators.required]),
        'ApplyingRiskPRSV': new FormControl(this.row_obj.ApplyingRiskPRSV, [Validators.required])
      })
    if(!clear){
      return riskD.valid;
    }else{
      return riskD.reset({
        AssociatedRisk : '',
        ApplicableControls : '',
        NotApplicableRiskPR : null,
        NotApplicableRiskSV : null,
        NotApplicableRiskPRSV : null,
        ApplyingRiskPR : null,
        ApplyingRiskSV : null,
        ApplyingRiskPRSV : null,
      });
    }
  }

  onProcessChange() {
    console.log('El tipo de orden seleccionado es:', this.option_processes);
    if (this.option_processes == 1) {
      this.getEntryReq();
      this.c_obj.WorkOrder = null;
      this.c_obj.Order = ''; // Limpia el input si se selecciona OT
      this.c_obj.WorkDescription = '';
      this.c_obj.PlantaName = '';
      this.c_obj.SeccionName = '';
      this.selected_id = true
    } else {
      this.GetPlantas();
      this.c_obj.WorkOrder = null; // Limpia el input si se selecciona OT
      this.c_obj.WorkDescription = '';
      this.c_obj.PlantaName = '';
      this.c_obj.SeccionName = '';
      this.c_obj.SeccionPlantaId = null;
      this.c_obj.PlantaId = null;
      // this.c_obj = {};
      // this.GetCompany();
      // this.setLevelArea()
      this.selected_id = false
    }
  }

//modal principal
  public openGiantModal() {
    this.GetPlantas();
    this.c_obj = {};
    this.c_obj['TaskAnalysisDetails'] = [];
    this.option_processes = null;
    this.disable_wo = false;
    this.selected_id = false;
    this.editItem = false;
    this.modal1Ref = this.modalService.open(this.create1, { backdrop: 'static', size: 'xl', scrollable: true});
  }
//añadir
  public openCreateModal() {
    this.selectState = {}
    this.row_obj = {};
    this.row_obj['RiskDetails'] = [];
    this.modal2Ref = this.modalService.open(this.create2, { backdrop: 'static', size: 'lg', scrollable: true});
  }

  public openReasonModal() {
    this.modal3Ref = this.modalService.open(this.reason, { backdrop: 'static', size: 'sm'});
  }

  public openUpdateGiantModal(obj: any){
    this.GetPlantas();
    console.log('openUpdateGiantModal', obj);
    this.c_obj = obj;
    this.c_obj['TaskAnalysisDetails'] = obj['TaskAnalysisDetails'];
    this.c_obj['AssignedDate'] = obj['AssignedDate'].split('T')[0];
debugger;
    this.disable_wo = true;
    if(obj['EntryRequestId'] != null){
      this.getEntryReq();
      this.option_processes = obj['TypeOrder'];
      this.c_obj['Order'] = obj['OrderVal'];
      this.c_obj['PlantaName'] = obj['PlantaName'];
      this.c_obj['SeccionName'] = obj['SeccionPlantaName'];
      this.selected_id = true;
      console.log('Option process',this.option_processes);
      console.log('Modal actualizar Orden de trabajo',this.c_obj);
    }else{
      this.setLevelArea();
      this.option_processes = obj['TypeOrder'];
      this.c_obj['Order'] = obj['OrderVal'];
      // this.c_obj['Order'] = this.c_obj.WorkOrder ? this.c_obj.WorkOrder : obj['OrderVal'];
      this.c_obj['PlantaId'] = obj['PlantaId'];
      this.c_obj['SeccionPlantaId'] = obj['SeccionPlantaId'];
      this.selected_id = true;
      console.log(this.c_obj);
    }
    this.modal1Ref = this.modalService.open(this.create1, { backdrop: 'static', size: 'xl', scrollable: true});
  }

  public openUpdateModal(r_obj: any, index: number){
    this.selectState = {}
    this.index = index;
    this.editItem = true;
    this.row_obj = r_obj;
    this.row_obj['RiskDetails'] = r_obj['RiskDetails'];
    this.modal2Ref = this.modalService.open(this.create2, { backdrop: 'static', size: 'lg', scrollable: true});
  }

  public openViewGiantModal(obj: any){
    console.log('approved', this.isApproved)
    console.log('Sketting', this.isSkretting)
    this.signatureGisis = this.getGisisSignature(obj['GISIS']);
    this.isGisisApproved = obj.ApprovedGisis === false;
    // if (obj.ApprovedGisis === true) {
    //   this.isGisisApproved = true;
    // } else {
    //   this.isGisisApproved = false; // opcional, en caso de que quieras dejarlo explícito
    // }
    console.log('approved', this.isApproved)
    console.log('Sketting', this.isSkretting)
    console.log('isDone', this.isDone)
    this.GetPlantas();
    this.c_obj = obj;
    this.c_obj['CompanyId'] = obj['CompanyId'];
    this.userinfo.selectedCompanyId = obj['CompanyId'];
    this.c_obj['TaskAnalysisDetails'] = obj['TaskAnalysisDetails'];
    this.c_obj['AssignedDate'] = obj['AssignedDate'].split('T')[0];
    this.viewData = true;
    this.disable_wo = true;
    this.GetEmployee();
    if(obj['EntryRequestId'] != null){
      this.getEntryReq();
      this.option_processes = obj['TypeOrder'];
      this.c_obj['Order'] = obj['OrderVal'];
      this.c_obj['WorkOrder'] = obj['OrderVal'];
      this.c_obj['PlantaName'] = obj['PlantaName'];
      this.c_obj['SeccionName'] = obj['SeccionPlantaName'];
      this.selected_id = true;
    }else{
      this.setLevelArea();
      this.option_processes = obj['TypeOrder'];
      this.c_obj['Order'] = obj['OrderVal'];
      this.c_obj['PlantaId'] = obj['PlantaId'];
      this.c_obj['SeccionPlantaId'] = obj['SeccionPlantaId'];
      this.selected_id = true;
    }
    if (obj.Approvers && obj.Approvers.split('-')[0] === obj.Approvers.split('-')[1]) {
      this.isDone = true;
    }else{
      this.isDone = false;
    }
    this.modal1Ref = this.modalService.open(this.create1, { backdrop: 'static', size: 'xl', scrollable: true});
  }

  getEntryReq(){
    var qst = API_GET_ENTRY_DATA + this.userinfo.selectedCompanyId;
    this.srv.getCall(qst).subscribe(
      (resp)=>{
        this.entryList = resp.val;
        console.log(this.entryList)
        const entry = this.entryList && this.entryList.find(e => e.WorkOrder === parseInt(this.c_obj['OrderVal']));
        this.c_obj.WorkOrder = entry ? entry.EntryRequestId : null;
        // this.workOrders = [...new Set(this.entryList.map(item => item.WorkOrder))];
        // console.log(this.workOrders)
      },
      (err)=>{
        Swal.fire(this.translations.empty, this.translations.not_registers, 'success');
        this.entryList = [];
        return;
      }
    )
  }

  onWorkOrderChange(selectedWorkOrder: any): void {
    const selectedItem = this.entryList.find(item => item.EntryRequestId === parseInt(selectedWorkOrder));
    if (selectedItem) {
      this.c_obj['EntryRequestId'] = selectedItem.EntryRequestId;
      this.c_obj['WorkDescription'] = selectedItem.WorkDescription;
      this.c_obj['CompanyName'] = selectedItem.CompanyName;
      this.c_obj['PlantaName'] = selectedItem.PlantaName;
      this.c_obj['SeccionName'] = selectedItem.SeccionName;
      this.c_obj['PlantaId'] = selectedItem.PlantaID;
      this.selected_id = true;
      this.getApprovers(selectedItem.PlantaID);
    } else {
      this.c_obj['WorkDescription'] = "";
      this.c_obj['CompanyName'] = "";
      this.c_obj['SeccionName'] = "";
      this.selected_id = false
    }
    console.log('Selected Work Order this.c_obj:', this.c_obj);
  }

  private getParamToolTip(){
    var qst = API_GET_PARAM_TOOLTIP;
    this.srv.getCall(qst).subscribe(
      (resp) => {
        if (resp && resp.val) {
          this.paramList = resp.val;

          const fieldMap: { [key: string]: keyof FormARTComponent } = {
            "FORM_ART_STEPBYSTEP": "stepbystep",
            "FORM_ART_TOOLS": "tools",
            "FORM_ART_ASSOCIATED_RISK": "associatedrisk",
            "FORM_ART_ASSESSMENT_APPLYING_WITHOUT_CONTROLS": "riskwithout",
            "FORM_ART_APPLICABLE_CONTROLS": "applicablecontrol",
            "FORM_ART_EPPS": "epps",
            "FORM_ART_ASSESSMENT_APPLYING_CONTROLS": "applicablerisk",
            "FORM_ART_PTS_REQUIRED": "ptsrequired",
          };

          this.paramList.forEach(param => {
            if (fieldMap[param.field]) {
              this[fieldMap[param.field]] = param.value;
            }
          });
        } else {
          Swal.fire(this.translations.empty, this.translations.not_registers, 'success');
          this.paramList = [];
        }
      },
      (err) => {
        Swal.fire(err.msg || 'Error desconocido', '', 'error');
      }
    );
  }

  private getlistParamRisk(){
    var qst = API_PARAM_RISK_MATRIX_ALL;
    this.srv.getCall(qst).subscribe(
      (resp)=>{
        this.selectObj = resp.val;
        // console.log(this.selectObj)
      },
      (err)=>{
        Swal.fire(this.translations.empty, this.translations.not_registers, 'success');
        this.selectObj = [];
        return;
      }
    )
  }

  onParamRiskSelect(selectedParamRisk: any, key: string): void {
    const selectedItem = this.selectObj.find(item => item.ParamRiskMatrixId === parseInt(selectedParamRisk, 10));
    const exists = this.selectState.hasOwnProperty(key);

    if (selectedItem) {
      if (exists) {
        this.selectState[key].color = selectedItem.Color;
        this.selectState[key].tooltip = selectedItem.Description;
        this.selectState[key].val = selectedItem.ParamRiskMatrixId;
        this.selectState[key].desc = selectedItem.Parameter;
      } else {
        this.selectState[key] = {
          color: selectedItem.Color,
          tooltip: selectedItem.Description,
          val: selectedItem.ParamRiskMatrixId,
          desc: selectedItem.Parameter
        };
      }
      if(key == 'NotApplicableRiskPR' || key == 'NotApplicableRiskSV'){
        this.calculatePrSv('NotApplicableRiskPRSV');
      }else{
        this.calculatePrSv('ApplyingRiskPRSV');
      }

    } else {
      this.selectState[key] = { color: '', tooltip: '', val: null, desc: '' };
    }
  }

  private calculatePrSv(value: string){
    // if(this.selectState){
      const valid = (this.selectState['NotApplicableRiskPR'] != null || this.selectState['NotApplicableRiskPR'] != undefined) && (this.selectState['NotApplicableRiskSV'] != null || this.selectState['NotApplicableRiskSV'] != undefined);
      const valid2 = (this.selectState['ApplyingRiskPR'] != null || this.selectState['ApplyingRiskPR'] != undefined) && (this.selectState['ApplyingRiskSV'] != null || this.selectState['ApplyingRiskSV'] != undefined);
      var flag_id: number;
      let data: any;
      if(value == 'NotApplicableRiskPRSV'){
        flag_id = this.selectState['NotApplicableRiskPR'].val * this.selectState['NotApplicableRiskSV'].val;
        if(flag_id != undefined || flag_id != null){
          switch (valid) {
          case (flag_id >= 16 && flag_id <= 20):
            data = this.selectObj.find(item => item.ParamRiskMatrixId === 4);
            this.selectState['NotApplicableRiskPRSV'] = {
              color: data.Color,
              tooltip: data.Description,
              val: data.ParamRiskMatrixId,
              desc: data.Parameter
            };
            this.row_obj.NotApplicableRiskPRSV = this.selectState['NotApplicableRiskPRSV'].val
            break;
          case (flag_id >= 24 && flag_id <= 25):
            data = this.selectObj.find(item => item.ParamRiskMatrixId === 5);
            this.selectState['NotApplicableRiskPRSV'] = {
              color: data.Color,
              tooltip: data.Description,
              val: data.ParamRiskMatrixId,
              desc: data.Parameter
            };
            this.row_obj.NotApplicableRiskPRSV = this.selectState['NotApplicableRiskPRSV'].val
            break;
          case (flag_id >= 30 && flag_id <= 36):
            data = this.selectObj.find(item => item.ParamRiskMatrixId === 6);
            this.selectState['NotApplicableRiskPRSV'] = {
              color: data.Color,
              tooltip: data.Description,
              val: data.ParamRiskMatrixId,
              desc: data.Parameter
            };
            this.row_obj.NotApplicableRiskPRSV = this.selectState['NotApplicableRiskPRSV'].val
            break;
          }
        }else{
          return;
        }
      }else if(value == 'ApplyingRiskPRSV'){
        flag_id = this.selectState['ApplyingRiskPR'].val * this.selectState['ApplyingRiskSV'].val;
        if(flag_id != undefined || flag_id != null) {
          switch (valid2) {
            case (flag_id >= 16 && flag_id <= 20):
              data = this.selectObj.find(item => item.ParamRiskMatrixId === 4);
              this.selectState['ApplyingRiskPRSV'] = {
                color: data.Color,
                tooltip: data.Description,
                val: data.ParamRiskMatrixId,
                desc: data.Parameter
              };
              this.row_obj.ApplyingRiskPRSV = this.selectState['ApplyingRiskPRSV'].val
              break;
            case (flag_id >= 24 && flag_id <= 25):
              data = this.selectObj.find(item => item.ParamRiskMatrixId === 5);
              this.selectState['ApplyingRiskPRSV'] = {
                color: data.Color,
                tooltip: data.Description,
                val: data.ParamRiskMatrixId,
                desc: data.Parameter
              };
              this.row_obj.ApplyingRiskPRSV = this.selectState['ApplyingRiskPRSV'].val
              break;
            case (flag_id >= 30 && flag_id <= 36):
              data = this.selectObj.find(item => item.ParamRiskMatrixId === 6);
              this.selectState['ApplyingRiskPRSV'] = {
                color: data.Color,
                tooltip: data.Description,
                val: data.ParamRiskMatrixId,
                desc: data.Parameter
              };
              this.row_obj.ApplyingRiskPRSV = this.selectState['ApplyingRiskPRSV'].val
              break;
          }
        }else{
          return;
        }
      }
    // }
  }

  public GetCompany() {
    var qst = API_CONSULTACOMPANIES;
    this.srv.getCall(qst).subscribe(x => {
      if(x.success){
        if(x.val != null){
          var rs = x.val.filter(element => element.Status === "A");
          this.row_company = rs;
        }else {
          this.row_company = [];
          return;
        }
      }else {
        return;
      }
    });
  }

  public GetPlantas() {
    var qst = GET_ALL_SITES_ACTIVE;
    this.srv.getCall(qst).subscribe(x => {
      if(x.success){
        if(x.val != null){
          var rs = x.val;
          this.row_plantas = rs;
        }else {
          this.row_plantas = [];
          return;
        }
      }else {
        return;
      }
    });
  }
  public setLevelArea() {
    this.getApprovers(this.c_obj['PlantaId']);
    if (this.c_obj['PlantaId'] !== null) {
      if(!this.disable_wo){
      var qst = GET_ALL_AREA_BY_ID + this.c_obj['PlantaId'].split('-')[0];
      }else {
      var qst = GET_ALL_AREA_BY_ID + this.c_obj['PlantaId'];
      }
      this.srv.getCall(qst).subscribe(x => {
        if(x.success){
          if(x.val != null){
            var rs = x.val;
            this.row_plantas_area = rs;
          }else {
            this.row_plantas_area = [];
            return;
          }
        }else {
          return;
        }
      });
    } else {
      this.row_plantas_area = [];
    }
  }
  public setLevelAreaold() {
    var qst = API_CONSULTAAREAS;
    this.srv.getCall(qst).subscribe(x => {
      if(x.success){
        if(x.val != null){
          var rs = x.val;
          this.row_plantas_area = rs;
          console.log('row_plantas_area', this.row_plantas_area);
        }else {
          this.row_plantas_area = [];
          return;
        }
      }else {
        return;
      }
    });
  }

  public addParameter(obj: any){
    var validated : any;
    if( obj == undefined ){
      obj = {};
    }

    validated = this.validateRiskDetail(obj, false);

    if(!validated){
      this.isCreating = false;
      Swal.fire(this.translations['msg_all_required'], '', 'error');
      return;
    }

    if (this.row_obj['RiskDetails'].length === 0) {
      this.row_obj['RiskDetails'].push(
        {
          AssociatedRisk: obj['AssociatedRisk'],
          NotApplicableRiskPR: obj['NotApplicableRiskPR'],
          NotApplicableRiskSV: obj['NotApplicableRiskSV'],
          NotApplicableRiskPRSV: obj['NotApplicableRiskPRSV'],
          ApplicableControls: obj['ApplicableControls'],
          ApplyingRiskPR: obj['ApplyingRiskPR'],
          ApplyingRiskSV: obj['ApplyingRiskSV'],
          ApplyingRiskPRSV: obj['ApplyingRiskPRSV'],
        }
      );
    } else {
      let count = 0;
      let typeEmergency = '';
      if (count > 0) {
        this.row_obj['AssociatedRisk'] = null;
        this.row_obj['ApplicableControls'] = null;
        this.row_obj['NotApplicableRiskPR'] = null;
        this.row_obj['NotApplicableRiskSV'] = null;
        this.row_obj['NotApplicableRiskPRSV'] = null;
        this.row_obj['ApplyingRiskPR'] = null;
        this.row_obj['ApplyingRiskSV'] = null;
        this.row_obj['ApplyingRiskPRSV'] = null;
        // this.validateRiskDetail(this.row_obj, true);
        this.selectState = {}
        return Swal.fire(
          this.translations.error_creation_proadd,
          this.translations.cant_create_distinct_pro_add,
          'error');
      } else {
        this.row_obj['RiskDetails'].push(
          {
            AssociatedRisk: obj['AssociatedRisk'],
            NotApplicableRiskPR: obj['NotApplicableRiskPR'],
            NotApplicableRiskSV: obj['NotApplicableRiskSV'],
            NotApplicableRiskPRSV: obj['NotApplicableRiskPRSV'],
            ApplicableControls: obj['ApplicableControls'],
            ApplyingRiskPR: obj['ApplyingRiskPR'],
            ApplyingRiskSV: obj['ApplyingRiskSV'],
            ApplyingRiskPRSV: obj['ApplyingRiskPRSV'],
          }
        );
      }
    }

      this.row_obj['AssociatedRisk'] = null;
      this.row_obj['ApplicableControls'] = null;
      this.row_obj['NotApplicableRiskPR'] = null;
      this.row_obj['NotApplicableRiskSV'] = null;
      this.row_obj['NotApplicableRiskPRSV'] = null;
      this.row_obj['ApplyingRiskPR'] = null;
      this.row_obj['ApplyingRiskSV'] = null;
      this.row_obj['ApplyingRiskPRSV'] = null;
    // this.validateRiskDetail(this.row_obj, true);
    this.selectState = {}
    console.log(this.row_obj['RiskDetails']);
  }

  public delParameter(robj:any, position:number): void{
    robj['RiskDetails'].splice(position, 1);
    console.log(this.row_obj['RiskDetails']);
  }

  public delParameterTask(position: number): void {
    if (
      this.c_obj &&
      this.c_obj.TaskAnalysisDetails &&
      Array.isArray(this.c_obj.TaskAnalysisDetails)
    ) {
      this.c_obj.TaskAnalysisDetails.splice(position, 1);
      console.log('Actualizado:', this.c_obj.TaskAnalysisDetails);
    } else {
      console.error('TaskAnalysisDetails no está definido correctamente.');
    }
  }

  getColor(id: number): string {
    const foundObject = this.selectObj.find(item => item.ParamRiskMatrixId === id);
    return foundObject ? foundObject.Color : 'transparent';
  }

  getParameter(id: number): string {
    const foundObject = this.selectObj.find(item => item.ParamRiskMatrixId === id);
    return foundObject ? foundObject.Parameter : '';
  }

  deleteItem(val : any){
    var qst = API_DELETETASKRISKANALYSIS;
    var to:any;
    to = {};
    to.TaskRiskAnalysisId = val.TaskRiskAnalysisId;
    // to.Status = "I";
    to.DeleteUser = this.userinfo['userId'];
    this.srv.postCall(qst, to).subscribe(x => {
      this.isCreating = false;
      Swal.close();
      if(x.success){
        this.reload.next(true);
        Swal.fire(this.translations['MENSAJE'], x.msg, 'success');
        this.getList();
      }
      else{
        Swal.fire(x.msg, '', 'error');
      }
    }, err => {
      Swal.close();
      Swal.fire('Error');
    });
  }

  private sendMailART(data: any){
    var to:any;
    to = {};
    to = {
      CompanyId: this.userinfo.userId,
      TaskRiskAnalysisId: data.TaskRiskAnalysisId,
      PlantaId: data.PlantaId,
      GISIS: data.GISIS,
    };
    let qst = API_SENDMAIL_TASKRISKANALYSIS;
    this.srv.postCall(qst ,to).subscribe(x => {
      this.isCreating = false;
    }, err => {
      Swal.close();
      Swal.fire('Error');
    });
  }
  private sendMailARTApproved(data: any){
    debugger
    var to:any;
    to = {};
    to = {
      CompanyId: data.TaskRiskAnalysis.CompanyId,
      TaskRiskAnalysisId: data.TaskRiskAnalysisId,
      PlantaId: data.TaskRiskAnalysis.PlantaId,
      GISIS: data.TaskRiskAnalysis.GISIS,
    };
    let qst = API_POST_SENDMAIL_TASKRISKAPPROVED;
    this.srv.postCall(qst ,to).subscribe(x => {
      this.isCreating = false;
    }, err => {
      Swal.close();
      Swal.fire('Error');
    });
  }

  async downloadExcel2(): Promise<void> {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Análisis de Riesgos');

    // Definir algunos estilos reutilizables
    // Los estilos se asignan directamente al objeto de estilo de la celda
    const headerCellStyle: Partial<{ font: Partial<Font>, alignment: Partial<Alignment>, border: { top: { style: BorderStyle }, left: { style: BorderStyle }, bottom: { style: BorderStyle }, right: { style: BorderStyle } } }> = {
      font: { name: 'Arial', size: 10, bold: true },
      alignment: { vertical: 'middle', horizontal: 'left' },
      border: {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    };

    const valueCellStyle: Partial<{ font: Partial<Font>, alignment: Partial<Alignment>, border: { top: { style: BorderStyle }, left: { style: BorderStyle }, bottom: { style: BorderStyle }, right: { style: BorderStyle } } }> = {
      font: { name: 'Arial', size: 10 },
      alignment: { vertical: 'middle', horizontal: 'left' },
      border: {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    };

    const titleCellStyle: Partial<{ font: Partial<Font>, alignment: Partial<Alignment>, fill: Partial<Fill> }> = {
      font: { name: 'Arial', size: 14, bold: true },
      alignment: { vertical: 'middle', horizontal: 'center' },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD9E1F2' } // Un tono de azul claro
      }
    };

    const sectionHeaderStyle: Partial<{ font: Partial<Font>, alignment: Partial<Alignment>, fill: Partial<Fill>, border: { top: { style: BorderStyle }, left: { style: BorderStyle }, bottom: { style: BorderStyle }, right: { style: BorderStyle } } }> = {
      font: { name: 'Arial', size: 10, bold: true },
      alignment: { vertical: 'middle', horizontal: 'left' },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD9D9D9' } // Gris claro
      },
      border: {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    };

    // Ajustar anchos de columna (aproximado, puedes ajustarlos mejor)
    const columnWidths: { [key: string]: number } = {
      A: 5,
      B: 25,
      C: 30,
      D: 25,
      E: 10,
      F: 10,
      G: 10,
      H: 40,
      I: 30,
      J: 10,
      K: 10,
      L: 10,
      M: 15,
    };

// Itera sobre el objeto y aplica los anchos
    for (const columnLetter in columnWidths) {
      if (columnWidths.hasOwnProperty(columnLetter)) {
        worksheet.getColumn(columnLetter).width = columnWidths[columnLetter];
      }
    }

    // --- FILA 1: LOGO NUTRECO Y REGISTRO ---
    worksheet.mergeCells('A1:C1');
    worksheet.getCell('A1').value = 'REGISTRO';
    // CORRECCIÓN: Asignación directa de estilos
    worksheet.getCell('A1').font = { name: 'Arial', size: 16, bold: true };
    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'left' };

    // IMAGEN
    worksheet.mergeCells('D1:M1');
    worksheet.getCell('D1').value = ''; // Vacío como en la imagen
    Object.assign(worksheet.getCell('D1'), valueCellStyle);

    // --- FILA 2: Internal y Document nr. / Revision / Effective date ---
    worksheet.mergeCells('A2:G2');
    worksheet.getCell('A2').value = 'Internal';
    // CORRECCIÓN: Asignación directa de estilos
    worksheet.getCell('A2').font = { name: 'Arial', size: 12, italic: true };
    worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'left' };

    worksheet.mergeCells('H2:M2');
    worksheet.getCell('H2').value = 'Document nr: SSO-R04.02-1';
    // Aplicar estilos del objeto predefinido
    Object.assign(worksheet.getCell('H2'), headerCellStyle); // Aquí sí usa Object.assign para copiar propiedades del objeto headerCellStyle

    // --- FILA 3 Y 4: Análisis de Riesgos de Tareas ART y Revision -- Effective date ---
    worksheet.mergeCells('A3:G4');
    worksheet.getCell('A3').value = 'Análisis de Riesgos de Tareas ART';
    Object.assign(worksheet.getCell('A3'), titleCellStyle); // Aquí sí usa Object.assign para copiar propiedades del objeto titleCellStyle

    worksheet.mergeCells('H3:M3');
    worksheet.getCell('H3').value = 'Revision: 00';
    Object.assign(worksheet.getCell('H3'), headerCellStyle);

    worksheet.mergeCells('H4:M4');
    worksheet.getCell('H4').value = 'Effective date: August 10, 2022';
    Object.assign(worksheet.getCell('H4'), headerCellStyle);

    // --- FILA 5: Document Owner y Approver(s) ---
    worksheet.mergeCells('A5:E5');
    worksheet.getCell('A5').value = 'Document Owner: Marola Parrales';
    Object.assign(worksheet.getCell('A5'), headerCellStyle);

    worksheet.mergeCells('F5:M5');
    worksheet.getCell('F5').value = 'Approver(s): Ener Parrales';
    Object.assign(worksheet.getCell('F5'), headerCellStyle);

    // --- FILA 6: Descripción de trabajo y Type Order  ---
    worksheet.mergeCells('A6:B6');
    worksheet.getCell('A6').value = 'Descripción de trabajo a ejecutar:';
    worksheet.getCell('A6').alignment = { ...worksheet.getCell('A6').alignment, wrapText: true };
    Object.assign(worksheet.getCell('A6'), headerCellStyle);

    worksheet.mergeCells('C6:I6');
    worksheet.getCell('C6').value = 'VALORES DESCRIPCION';
    Object.assign(worksheet.getCell('C6'), valueCellStyle);

    worksheet.mergeCells('J6:L6');
    worksheet.getCell('J6').value = 'OT#'; // Vacío como en la imagen
    Object.assign(worksheet.getCell('J6'), headerCellStyle);

    worksheet.getCell('M6').value = 'VALORES OT'; // Vacío como en la imagen
    Object.assign(worksheet.getCell('M6'), valueCellStyle);

    // --- FILA 7: Compañía contratista y Área ---
    worksheet.mergeCells('A7:B7');
    worksheet.getCell('A7').value = 'Compañía contratista';
    Object.assign(worksheet.getCell('A7'), headerCellStyle);

    worksheet.mergeCells('C7:F7');
    worksheet.getCell('C7').value = 'VALOR COMPAÑIA';
    Object.assign(worksheet.getCell('C7'), valueCellStyle);

    worksheet.mergeCells('G7:M7');
    worksheet.getCell('G7').value = 'Área: VALOR DE AREA';
    Object.assign(worksheet.getCell('G7'), headerCellStyle);

    // --- FILA 8: Responsable de Seguridad de la contratista y Sub - Área ---
    worksheet.mergeCells('A8:B8');
    worksheet.getCell('A8').value = 'Responsable de Seguridad de la contratista:';
    worksheet.getCell('A8').alignment = { ...worksheet.getCell('A8').alignment, wrapText: true };
    Object.assign(worksheet.getCell('A8'), headerCellStyle);

    worksheet.mergeCells('C8:F8');
    worksheet.getCell('C8').value = 'VALOR RESPONSABLE';
    Object.assign(worksheet.getCell('C8'), valueCellStyle);

    worksheet.mergeCells('G8:M8');
    worksheet.getCell('G8').value = 'Sub - Área: VALOR DE SUB-AREA';
    Object.assign(worksheet.getCell('G8'), headerCellStyle);

    // worksheet.mergeCells('A8:B8');
    // worksheet.getCell('A8').value = ''; // Usar \n para salto de línea
    // Object.assign(worksheet.getCell('A8'), headerCellStyle);
    // // CORRECCIÓN: Asignación directa de alignment.wrapText
    // worksheet.getCell('A7').alignment = { ...worksheet.getCell('A7').alignment, wrapText: true };
    // worksheet.getCell('B7').value = 'Fausto';
    // Object.assign(worksheet.getCell('B7'), valueCellStyle);

    // --- FILA 9: Persona de GISIS Contratante y Fecha ---
    worksheet.mergeCells('A9:B9');
    worksheet.getCell('A9').value = 'Persona de GISIS Contratante:';
    Object.assign(worksheet.getCell('A9'), headerCellStyle);

    worksheet.mergeCells('C9:F9');
    worksheet.getCell('C9').value = 'VALOR GISIS';
    Object.assign(worksheet.getCell('C9'), valueCellStyle);

    worksheet.mergeCells('G9:M9');
    worksheet.getCell('G9').value = 'Fecha: VALOR DE FECHA';
    Object.assign(worksheet.getCell('G9'), headerCellStyle);

    // --- FILA 10: Encabezados de tabla ---
    worksheet.mergeCells('A10:B10');
    worksheet.getCell('A10').value = 'Paso a Paso';
    Object.assign(worksheet.getCell('A10'), sectionHeaderStyle);
    worksheet.getCell('A10').alignment = { ...worksheet.getCell('A10').alignment, horizontal: 'center', vertical: 'middle' };

    worksheet.getCell('C10').value = 'Herramientas / equipos que requiere';
    Object.assign(worksheet.getCell('C10'), sectionHeaderStyle);
    worksheet.getCell('C10').alignment = { ...worksheet.getCell('C10').alignment, horizontal: 'center', vertical: 'middle', wrapText: true };

    worksheet.getCell('D10').value = 'Riesgos asociados';
    Object.assign(worksheet.getCell('D10'), sectionHeaderStyle);
    worksheet.getCell('D10').alignment = { ...worksheet.getCell('D10').alignment, horizontal: 'center', vertical: 'middle' };

    worksheet.mergeCells('E10:G10');
    worksheet.getCell('E10').value = 'Evaluación de riesgos sin aplicar controles (ver instrucciones)';
    Object.assign(worksheet.getCell('E10'), sectionHeaderStyle);
    worksheet.getCell('E10').alignment = { ...worksheet.getCell('E10').alignment, horizontal: 'center', vertical: 'middle', wrapText: true };

    worksheet.getCell('H10').value = 'Controles Aplicables';
    Object.assign(worksheet.getCell('H10'), sectionHeaderStyle);
    worksheet.getCell('H10').alignment = { ...worksheet.getCell('H10').alignment, horizontal: 'center', vertical: 'middle' };

    worksheet.getCell('I10').value = 'EPPs';
    Object.assign(worksheet.getCell('I10'), sectionHeaderStyle);
    worksheet.getCell('I10').alignment = { ...worksheet.getCell('I10').alignment, horizontal: 'center', vertical: 'middle' };

    worksheet.mergeCells('J10:L10');
    worksheet.getCell('J10').value = 'Evaluación de riesgos aplicando controles (ver instrucciones)';
    Object.assign(worksheet.getCell('J10'), sectionHeaderStyle);
    worksheet.getCell('J10').alignment = { ...worksheet.getCell('J10').alignment, horizontal: 'center', vertical: 'middle', wrapText: true };

    worksheet.getCell('M10').value = 'PTS requerido';
    Object.assign(worksheet.getCell('M10'), sectionHeaderStyle);
    worksheet.getCell('M10').alignment = { ...worksheet.getCell('M10').alignment, horizontal: 'center', vertical: 'middle' };

    // Fila 11 (sub-encabezados para Evaluación de riesgos)
    worksheet.getCell('A11').value = '#';
    Object.assign(worksheet.getCell('A11'), valueCellStyle);
    worksheet.getCell('A11').alignment = { ...worksheet.getCell('A11').alignment, vertical: 'top'};

    worksheet.getCell('B11').value = this.stepbystep;
    Object.assign(worksheet.getCell('B11'), valueCellStyle);
    worksheet.getCell('B11').alignment = { ...worksheet.getCell('B11').alignment, vertical: 'top', wrapText: true };

    worksheet.getCell('C11').value = this.tools;
    Object.assign(worksheet.getCell('C11'), valueCellStyle);
    worksheet.getCell('C11').alignment = { ...worksheet.getCell('C11').alignment, vertical: 'top', wrapText: true };

    worksheet.getCell('D11').value = this.associatedrisk;
    Object.assign(worksheet.getCell('D11'), valueCellStyle);
    worksheet.getCell('D11').alignment = { ...worksheet.getCell('D11').alignment, vertical: 'top', wrapText: true };

    worksheet.getCell('E11').value = 'Pr';
    Object.assign(worksheet.getCell('E11'), valueCellStyle);
    worksheet.getCell('E11').alignment = { ...worksheet.getCell('E11').alignment, vertical: 'top', wrapText: true };

    worksheet.getCell('F11').value = 'Sv';
    Object.assign(worksheet.getCell('F11'), valueCellStyle);
    worksheet.getCell('F11').alignment = { ...worksheet.getCell('F11').alignment, vertical: 'top', wrapText: true };

    worksheet.getCell('G11').value = 'Riesgo Pr*Sv';
    Object.assign(worksheet.getCell('G11'), valueCellStyle);
    worksheet.getCell('G11').alignment = { ...worksheet.getCell('G11').alignment, vertical: 'top', wrapText: true };

    worksheet.getCell('H11').value = this.applicablecontrol;
    Object.assign(worksheet.getCell('H11'), valueCellStyle);
    // CORRECCIÓN: Asignación directa de alignment
    worksheet.getCell('H11').alignment = { ...worksheet.getCell('H11').alignment, vertical: 'top', wrapText: true };

    worksheet.getCell('I11').value = this.epps;
    Object.assign(worksheet.getCell('I11'), valueCellStyle);
    // CORRECCIÓN: Asignación directa de alignment
    worksheet.getCell('I11').alignment = { ...worksheet.getCell('I11').alignment, vertical: 'top', wrapText: true };

    worksheet.getCell('J11').value = 'Pr';
    Object.assign(worksheet.getCell('J11'), valueCellStyle);
    worksheet.getCell('J11').alignment = { ...worksheet.getCell('J11').alignment, vertical: 'top', wrapText: true };

    worksheet.getCell('K11').value = 'Sv';
    Object.assign(worksheet.getCell('K11'), valueCellStyle);
    worksheet.getCell('K11').alignment = { ...worksheet.getCell('K11').alignment, vertical: 'top', wrapText: true };

    worksheet.getCell('L11').value = 'Riesgo Pr*Sv';
    Object.assign(worksheet.getCell('L11'), valueCellStyle);
    worksheet.getCell('L11').alignment = { ...worksheet.getCell('L11').alignment, vertical: 'top', wrapText: true };

    worksheet.getCell('M11').value = this.ptsrequired;
    Object.assign(worksheet.getCell('M11'), valueCellStyle);
    // CORRECCIÓN: Asignación directa de alignment
    worksheet.getCell('M11').alignment = { ...worksheet.getCell('M11').alignment, vertical: 'top', wrapText: true };


    // Generar el archivo Excel
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'AnalisisDeRiesgos.xlsx');
    });
  }

  getColorExcel(id: number): string {
    const foundObject = this.selectObj.find(item => item.ParamRiskMatrixId === id);
    if (foundObject && foundObject.Color) {
      // Elimina el '#' y añade 'FF' al principio para opacidad total
      return 'FF' + foundObject.Color.substring(1);
    }
    return 'FFFFFFFF'; // Blanco por defecto si no se encuentra o el color es inválido
  }
  // public onGisisChange(userId: any): void {
  //   const selectedUser = this.row_userGisis.find(user => user.UserId === parseInt(userId));
  //   this.signatureGisis = selectedUser ? selectedUser.signature : null;
  //   console.log('Signature Gisis:', this.signatureGisis);
  // }
  // public onSecurityCompanyChange(userId: any): void {
  //   const selectedUser = this.row_employee.find(user => user.EmployeeId === parseInt(userId));
  //   this.signatureCompany = selectedUser ? selectedUser.Signature : null;
  //   console.log('Signature Security Company:', this.signatureCompany);
  // }
  public getGisisSignature(userId: any): string | null {
    const selectedUser = this.row_userGisis.find(user => user.UserId === parseInt(userId));
    this.isApproved=true;
    return selectedUser ? selectedUser.signature : null;
  }
  public getSecurityCompanySignature(userId: any): string | null {
    const selectedUser = this.row_employee.find(user => user.EmployeeId === parseInt(userId));
    return selectedUser ? selectedUser.Signature : null;
  }
  public getAppoverSignature(userId: any): string | null {
      const selectedUser = this.list_pprovers.find(user => user.PlantaId  === parseInt(userId));
      return selectedUser ? selectedUser.signature : null;
    }

    async downloadExcel(obj: any): Promise<void> {debugger
      console.log('estado del send',obj.SendApprove);
      this.c_obj['CompanyId'] = obj['CompanyId'];
      this.c_obj['ApprovedHSE'] = obj['ApprovedHSE'];
    if (!this.row_employee || this.row_employee.length === 0) {
      await this.GetEmployee();
    }
    if (obj.SendApprove) {
      this.signatureCompany = this.getSecurityCompanySignature(obj['SecurityCompany']);
    }
    else {
      this.signatureCompany = null;
    }
    if(obj.ApprovedGisis){
      this.signatureGisis = this.getGisisSignature(obj['GISIS']);
    }
    else {
      this.signatureGisis = null;
    }
    if (obj.Approvers && obj.Approvers.split('-')[0] === obj.Approvers.split('-')[1]) {
      // this.signatureApprover = this.getApprovers(obj['PlantaId']);
     await this.getApprovers(obj['PlantaId']);
    }else{
      this.signatureApprover="";
    }
    console.log('firma signatureApprover ', this.signatureApprover);
    // console.log('firma signatureCompany ', this.signatureCompany);
    // console.log('firma signatureGisis ', this.signatureGisis);

    // 0️⃣ GENERAR NOMBRE Y URL DEL QR ⇐ AQUI
    const companyName = obj.CompanyName.replace(/[^a-zA-Z0-9]/g, '_');
    const taskId = obj.TaskRiskAnalysisId;
    const status = obj.StatusName || 'Desconocido'; // Por si acaso viene nulo
    const statusClean = status.replace(/[^a-zA-Z0-9]/g, '_');
      const timestamp = new Date().toISOString().split('T')[0].replace(/-/g, '_');
    const filename = `ART_${taskId}_${statusClean}_${companyName}_${timestamp}.xlsx`;
    const filePath = `/Documents/CompanyDocuments/${obj.CompanyId}/${filename}`;
    const baseUrl = window.location.origin;
    const fileUrl = `${baseUrl}${filePath}`;
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Análisis de Riesgos');

    // --- 1. Definir estilos reutilizables ---
    const headerCellStyle: Partial<{ font: Partial<Font>, alignment: Partial<Alignment>, border: { top: { style: BorderStyle }, left: { style: BorderStyle }, bottom: { style: BorderStyle }, right: { style: BorderStyle } } }> = {
      font: { name: 'Arial', size: 10, bold: true },
      alignment: { vertical: 'middle', horizontal: 'left' },
      border: {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    };

    const valueCellStyle: Partial<{ font: Partial<Font>, alignment: Partial<Alignment>, border: { top: { style: BorderStyle }, left: { style: BorderStyle }, bottom: { style: BorderStyle }, right: { style: BorderStyle } } }> = {
      font: { name: 'Arial', size: 10 },
      alignment: { vertical: 'middle', horizontal: 'left' },
      border: {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    };

    const titleCellStyle: Partial<{ font: Partial<Font>, alignment: Partial<Alignment>, fill: Partial<Fill> }> = {
      font: { name: 'Arial', size: 14, bold: true },
      alignment: { vertical: 'middle', horizontal: 'center' },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD9E1F2' } // Un tono de azul claro
      }
    };

    const sectionHeaderStyle: Partial<{ font: Partial<Font>, alignment: Partial<Alignment>, fill: Partial<Fill>, border: { top: { style: BorderStyle }, left: { style: BorderStyle }, bottom: { style: BorderStyle }, right: { style: BorderStyle } } }> = {
      font: { name: 'Arial', size: 10, bold: true, color: { argb: 'FFFFFFFF' } }, // Texto blanco para fila 10
      alignment: { vertical: 'middle', horizontal: 'left' },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF1D4D7F' } // Color de fondo azul oscuro que proporcionaste (hex #2D537B)
      },
      border: {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    };

    const sectionSubHeaderStyle: Partial<{ font: Partial<Font>, alignment: Partial<Alignment>, fill: Partial<Fill>, border: { top: { style: BorderStyle }, left: { style: BorderStyle }, bottom: { style: BorderStyle }, right: { style: BorderStyle } } }> = {
      font: { name: 'Arial', size: 10, bold: false },
      alignment: { vertical: 'middle', horizontal: 'center' }, // Centrado para fila 11
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFEAF2F8' } // Color de fondo azul claro que proporcionaste (hex #EAF2F8)
      },
      border: {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    };

    const mergedTaskDetailStyle: Partial<{ font: Partial<Font>, alignment: Partial<Alignment>, border: { top: { style: BorderStyle }, left: { style: BorderStyle }, bottom: { style: BorderStyle }, right: { style: BorderStyle } } }> = {
      font: { name: 'Arial', size: 10 },
      alignment: { vertical: 'top', horizontal: 'left', wrapText: true }, // Alinear arriba para una mejor legibilidad con celdas fusionadas
      border: {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    };

    const riskValueCellStyle: Partial<{ font: Partial<Font>, alignment: Partial<Alignment>, fill: Partial<Fill>, border: { top: { style: BorderStyle }, left: { style: BorderStyle }, bottom: { style: BorderStyle }, right: { style: BorderStyle } } }> = {
      font: { name: 'Arial', size: 10, bold: true, color: { argb: 'FF000000' } }, // Texto negro, negrita
      alignment: { vertical: 'middle', horizontal: 'center' }, // Centrado para los números de riesgo
      border: {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        // fgColor se asignará dinámicamente
      }
    };


    // --- 2. Ajustar anchos de columna (OPTIMIZADO) ---
    const columnWidths: { [key: string]: number } = {
      A: 5, B: 15, C: 30, D: 14, E: 3, F: 3, G: 8, H: 17, I: 17, J: 8, K: 8, L: 8, M: 15,
    };
    for (const columnLetter in columnWidths) {
      if (columnWidths.hasOwnProperty(columnLetter)) {
        worksheet.getColumn(columnLetter).width = columnWidths[columnLetter];
      }
    }

    // --- 3. Función auxiliar para aplicar estilos a celdas ---
    const applyCellStyles = (cell: Cell, config: CellConfig) => {
      cell.value = config.value;

      // Aplicar el estilo base primero
      if (config.style) {
        Object.assign(cell, config.style);
      }

      if (config.fontOverride) {
        cell.font = cell.font || {};
        Object.assign(cell.font, config.fontOverride);
      }

      if (config.alignmentOverride) {
        cell.alignment = cell.alignment || {};
        Object.assign(cell.alignment, config.alignmentOverride);
      }

      if (!cell.alignment) {
        cell.alignment = {};
      }
      cell.alignment.wrapText = true;
    };
      for (let rowIndex = 5; rowIndex <= 9; rowIndex++) {
        worksheet.getRow(rowIndex).height = 35; // Ajusta el número según lo que necesites
      }
    // --- 4. Configuración declarativa de todas las celdas ---
    const cellConfigurations: CellConfig[] = [
      // --- FILA 1: LOGO NUTRECO Y REGISTRO ---
      { address: 'A1', mergeTo: 'C1', value: 'REGISTRO', fontOverride: { name: 'Arial', size: 16, bold: true }, alignmentOverride: { vertical: 'middle', horizontal: 'left' } },
      { address: 'D1', mergeTo: 'M1', value: '', style: valueCellStyle },

      // --- FILA 2: Internal y Document nr. / Revision / Effective date ---
      { address: 'A2', mergeTo: 'G2', value: 'Internal', fontOverride: { name: 'Arial', size: 12, italic: true }, alignmentOverride: { vertical: 'middle', horizontal: 'left' } },
      { address: 'H2', mergeTo: 'M2', value: 'Document nr: SSO-R04.02-1', style: headerCellStyle },

      // --- FILA 3 Y 4: Análisis de Riesgos de Tareas ART y Revision -- Effective date ---
      { address: 'A3', mergeTo: 'G4', value: 'Análisis de Riesgos de Tareas ART', style: titleCellStyle },
      { address: 'H3', mergeTo: 'M3', value: 'Revision: 00', style: headerCellStyle },
      { address: 'H4', mergeTo: 'M4', value: 'Effective date: August 10, 2022', style: headerCellStyle },

      // --- FILA 5: Document Owner y Approver(s) ---
      { address: 'A5', mergeTo: 'E5', value: 'Document Owner: Marola Parrales', style: headerCellStyle },
      { address: 'F5', mergeTo: 'M5', value: 'Approver(s): Ener Parrales', style: headerCellStyle },

      // --- FILA 6: Descripción de trabajo y Type Order  ---
      { address: 'A6', mergeTo: 'B6', value: 'Descripción de trabajo a ejecutar:', style: headerCellStyle, alignmentOverride: { wrapText: true } },
      { address: 'C6', mergeTo: 'I6', value: obj.WorkDescription, style: valueCellStyle },
      { address: 'J6', mergeTo: 'L6', value: 'OT#', style: headerCellStyle },
      { address: 'M6', value: obj.OrderVal, style: valueCellStyle },

      // --- FILA 7: Compañía contratista y Área ---
      { address: 'A7', mergeTo: 'B7', value: 'Compañía contratista', style: headerCellStyle },
      { address: 'C7', mergeTo: 'F7', value: obj.CompanyName, style: valueCellStyle },
      { address: 'G7', mergeTo: 'M7', value: 'Área: ' + obj.SeccionPlantaName, style: headerCellStyle },

      // --- FILA 8: Responsable de Seguridad de la contratista y Sub - Área ---
      { address: 'A8', mergeTo: 'B8', value: 'Responsable de Seguridad de la contratista:', style: headerCellStyle, alignmentOverride: { wrapText: true } },
      { address: 'C8', mergeTo: 'F8', value: obj.SecurityCompanyName, style: valueCellStyle },
      { address: 'G8', mergeTo: 'M8', value: 'Sub - Área: '+ obj.SubArea, style: headerCellStyle },

      // --- FILA 9: Persona de GISIS Contratante y Fecha ---
      { address: 'A9', mergeTo: 'B9', value: 'Persona de GISIS Contratante:', style: headerCellStyle },
      { address: 'C9', mergeTo: 'F9', value: obj.GISISName, style: valueCellStyle },
      { address: 'G9', mergeTo: 'M9', value: 'Fecha: '+ obj.AssignedDate.split('T')[0], style: headerCellStyle },

      // --- FILA 10: Encabezados de tabla ---
      // Usar sectionHeaderStyle que ya tiene el color de fuente blanco y el color de fondo azul oscuro
      { address: 'A10', mergeTo: 'B10', value: 'Paso a Paso', style: sectionHeaderStyle, alignmentOverride: { horizontal: 'center', vertical: 'middle' } },
      { address: 'C10', value: 'Herramientas / equipos que requiere', style: sectionHeaderStyle, alignmentOverride: { horizontal: 'center', vertical: 'middle', wrapText: true } },
      { address: 'D10', value: 'Riesgos asociados', style: sectionHeaderStyle, alignmentOverride: { horizontal: 'center', vertical: 'middle' } },
      { address: 'E10', mergeTo: 'G10', value: 'Evaluación de riesgos sin aplicar controles (ver instrucciones)', style: sectionHeaderStyle, alignmentOverride: { horizontal: 'center', vertical: 'middle', wrapText: true } },
      { address: 'H10', value: 'Controles Aplicables', style: sectionHeaderStyle, alignmentOverride: { horizontal: 'center', vertical: 'middle' } },
      { address: 'I10', value: 'EPPs', style: sectionHeaderStyle, alignmentOverride: { horizontal: 'center', vertical: 'middle' } },
      { address: 'J10', mergeTo: 'L10', value: 'Evaluación de riesgos aplicando controles (ver instrucciones)', style: sectionHeaderStyle, alignmentOverride: { horizontal: 'center', vertical: 'middle', wrapText: true } },
      { address: 'M10', value: 'PTS requerido', style: sectionHeaderStyle, alignmentOverride: { horizontal: 'center', vertical: 'middle' } },

      // Fila 11 (sub-encabezados para Evaluación de riesgos)
      // Usar sectionSubHeaderStyle que ya tiene el color de fondo azul claro y la alineación centrada
      { address: 'A11', value: '#', style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top'} },
      { address: 'B11', value: this.stepbystep, style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top', wrapText: true } },
      { address: 'C11', value: this.tools, style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top', wrapText: true } },
      { address: 'D11', value: this.associatedrisk, style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top', wrapText: true } },
      { address: 'E11', value: 'Pr', style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top', wrapText: true } },
      { address: 'F11', value: 'Sv', style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top', wrapText: true } },
      { address: 'G11', value: 'Riesgo Pr*Sv', style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top', wrapText: true } },
      { address: 'H11', value: this.applicablecontrol, style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top', wrapText: true } },
      { address: 'I11', value: this.epps, style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top', wrapText: true } },
      { address: 'J11', value: 'Pr', style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top', wrapText: true } },
      { address: 'K11', value: 'Sv', style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top', wrapText: true } },
      { address: 'L11', value: 'Riesgo Pr*Sv', style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top', wrapText: true } },
      { address: 'M11', value: this.ptsrequired, style: sectionSubHeaderStyle, alignmentOverride: { vertical: 'top', wrapText: true } },

    ];

    // --- 5. Iterar sobre la configuración y aplicar ---
    cellConfigurations.forEach(config => {
      // Si la celda necesita ser fusionada, la fusionamos primero
      if (config.mergeTo) {
        worksheet.mergeCells(`${config.address}:${config.mergeTo}`);
      }
      // Obtener la celda y aplicar los estilos
      const cell = worksheet.getCell(config.address);
      applyCellStyles(cell, config);
    });

    // --- 6. Llenar los datos de la tabla (TaskAnalysisDetails y RiskDetails) ---
    let currentRow = 12; // Fila de inicio para los datos dinámicos

    for (const taskDetail of obj.TaskAnalysisDetails) {
      const taskIndex = obj.TaskAnalysisDetails.indexOf(taskDetail);
      const numRisks = taskDetail.RiskDetails.length;
      const startRowForTask = currentRow;
      const endRowForTask = currentRow + Math.max(1, numRisks) - 1; // Al menos una fila por detalle de tarea

      // Fusionar celdas para Paso a Paso, Herramientas / equipos, EPPs y PTS requerido
      if (numRisks > 0) {
        worksheet.mergeCells(`A${startRowForTask}:A${endRowForTask}`);
        worksheet.mergeCells(`B${startRowForTask}:B${endRowForTask}`);
        worksheet.mergeCells(`C${startRowForTask}:C${endRowForTask}`);
        worksheet.mergeCells(`I${startRowForTask}:I${endRowForTask}`);
        worksheet.mergeCells(`M${startRowForTask}:M${endRowForTask}`);
      }

      // Establecer valores para las celdas fusionadas (solo necesitan establecerse una vez para el rango fusionado)
      worksheet.getCell(`A${startRowForTask}`).value = taskIndex + 1; // #
      worksheet.getCell(`A${startRowForTask}`).style = mergedTaskDetailStyle;
      worksheet.getCell(`B${startRowForTask}`).value = taskDetail.StepByStep; // Paso a Paso
      worksheet.getCell(`B${startRowForTask}`).style = mergedTaskDetailStyle;
      worksheet.getCell(`C${startRowForTask}`).value = taskDetail.ToolsEquipmentRequired; // Herramientas / equipos que requiere
      worksheet.getCell(`C${startRowForTask}`).style = mergedTaskDetailStyle;
      worksheet.getCell(`I${startRowForTask}`).value = taskDetail.EPPs; // EPPs
      worksheet.getCell(`I${startRowForTask}`).style = mergedTaskDetailStyle;
      worksheet.getCell(`M${startRowForTask}`).value = taskDetail.RequiredPTS || ''; // PTS requerido
      worksheet.getCell(`M${startRowForTask}`).style = mergedTaskDetailStyle;

      if (numRisks === 0) {
        const row = worksheet.getRow(currentRow);
        row.eachCell((cell) => {
          Object.assign(cell, valueCellStyle); // Aplica estilos básicos a cada celda
          cell.alignment = cell.alignment || {};
          cell.alignment.wrapText = true;
        });
        currentRow++;
      }
        // else {
      //   taskDetail.RiskDetails.forEach((risk, riskIndex) => {
      //     const row = worksheet.getRow(currentRow + riskIndex);
      //
      //     row.getCell('D').value = risk.AssociatedRisk;
      //     row.getCell('E').value = risk.NotApplicableRiskPR;
      //     row.getCell('F').value = risk.NotApplicableRiskSV;
      //     row.getCell('G').value = risk.NotApplicableRiskPRSV;
      //     row.getCell('H').value = risk.ApplicableControls;
      //     row.getCell('J').value = risk.ApplyingRiskPR;
      //     row.getCell('K').value = risk.ApplyingRiskSV;
      //     row.getCell('L').value = risk.ApplyingRiskPRSV;
      //
      //     row.eachCell((cell) => {
      //       Object.assign(cell, valueCellStyle);
      //       cell.alignment = cell.alignment || {};
      //       cell.alignment.wrapText = true;
      //     });
      //   });
      else {
        taskDetail.RiskDetails.forEach((risk, riskIndex) => {
          const row = worksheet.getRow(currentRow + riskIndex);

          row.getCell('D').value = risk.AssociatedRisk;
          Object.assign(row.getCell('D'), valueCellStyle); // Aplicar estilo por defecto

          // --- Procesar NotApplicableRiskPR (Columna E) ---
          const notApplicableRiskPRId = risk.NotApplicableRiskPR;
          const notApplicableRiskPRValue = this.getParameter(notApplicableRiskPRId);
          const notApplicableRiskPRColor = this.getColorExcel(notApplicableRiskPRId);
          const cellE = row.getCell('E');
          Object.assign(cellE, riskValueCellStyle); // Aplicar el estilo base
          cellE.value = notApplicableRiskPRValue;
          cellE.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: notApplicableRiskPRColor }
          };

          // --- Procesar NotApplicableRiskSV (Columna F) ---
          const notApplicableRiskSVId = risk.NotApplicableRiskSV;
          const notApplicableRiskSVValue = this.getParameter(notApplicableRiskSVId);
          const notApplicableRiskSVColor = this.getColorExcel(notApplicableRiskSVId);
          const cellF = row.getCell('F');
          Object.assign(cellF, riskValueCellStyle);
          cellF.value = notApplicableRiskSVValue;
          cellF.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: notApplicableRiskSVColor }
          };

          // --- Procesar NotApplicableRiskPRSV (Columna G) ---
          const notApplicableRiskPRSVId = risk.NotApplicableRiskPRSV;
          const notApplicableRiskPRSVValue = this.getParameter(notApplicableRiskPRSVId);
          const notApplicableRiskPRSVColor = this.getColorExcel(notApplicableRiskPRSVId);
          const cellG = row.getCell('G');
          Object.assign(cellG, riskValueCellStyle);
          cellG.value = notApplicableRiskPRSVValue;
          cellG.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: notApplicableRiskPRSVColor }
          };

          row.getCell('H').value = risk.ApplicableControls;
          Object.assign(row.getCell('H'), valueCellStyle);

          // --- Procesar ApplyingRiskPR (Columna J) ---
          const applyingRiskPRId = risk.ApplyingRiskPR;
          const applyingRiskPRValue = this.getParameter(applyingRiskPRId);
          const applyingRiskPRColor = this.getColorExcel(applyingRiskPRId);
          const cellJ = row.getCell('J');
          Object.assign(cellJ, riskValueCellStyle);
          cellJ.value = applyingRiskPRValue;
          cellJ.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: applyingRiskPRColor }
          };

          // --- Procesar ApplyingRiskSV (Columna K) ---
          const applyingRiskSVId = risk.ApplyingRiskSV;
          const applyingRiskSVValue = this.getParameter(applyingRiskSVId);
          const applyingRiskSVColor = this.getColorExcel(applyingRiskSVId);
          const cellK = row.getCell('K');
          Object.assign(cellK, riskValueCellStyle);
          cellK.value = applyingRiskSVValue;
          cellK.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: applyingRiskSVColor }
          };

          // --- Procesar ApplyingRiskPRSV (Columna L) ---
          const applyingRiskPRSVId = risk.ApplyingRiskPRSV;
          const applyingRiskPRSVValue = this.getParameter(applyingRiskPRSVId);
          const applyingRiskPRSVColor = this.getColorExcel(applyingRiskPRSVId);
          const cellL = row.getCell('L');
          Object.assign(cellL, riskValueCellStyle);
          cellL.value = applyingRiskPRSVValue;
          cellL.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: applyingRiskPRSVColor }
          };

          // const cellsToStyle = ['D', 'E', 'F', 'G', 'H', 'J', 'K', 'L'];
          const cellsToStyle = ['A', 'B', 'C', 'I', 'M'];
          cellsToStyle.forEach(col => {
            const cell = row.getCell(col);
            if (!cell.style.border) cell.style.border = valueCellStyle.border;
            if (!cell.alignment) cell.alignment = {};
            cell.alignment.wrapText = true;
          });
        });
        currentRow += numRisks; // Mover a la siguiente fila disponible después de procesar todos los riesgos de esta tarea
      }





    }


// --- 0. Pre-procesar las imágenes Base64 ---
      // Elimina el prefijo "data:image/png;base64," para obtener solo los datos Base64
      const approverSignatureBase64 = this.signatureApprover ? this.signatureApprover.split(',')[1] : null;
      const gisisSignatureBase64 = this.signatureGisis ? this.signatureGisis.split(',')[1] : null;
      const companySignatureBase64 = this.signatureCompany ? this.signatureCompany.split(',')[1] : null;

      let approverImageId: number | null = null;
      let gisisImageId: number | null = null;
      let companyImageId: number | null = null;

      if (approverSignatureBase64) {
        approverImageId = workbook.addImage({
          base64: approverSignatureBase64,
          extension: 'png', // Asegúrate de que la extensión coincida con el tipo de imagen
        });
      }
      if (gisisSignatureBase64) {
        gisisImageId = workbook.addImage({
          base64: gisisSignatureBase64,
          extension: 'png',
        });
      }
      if (companySignatureBase64) {
        companyImageId = workbook.addImage({
          base64: companySignatureBase64,
          extension: 'png',
        });
      }
      // 🔻 Obtener última fila
      let lastRowNumber = worksheet.lastRow ? worksheet.lastRow.number : worksheet.rowCount;
      currentRow = lastRowNumber + 2;

      // 🎨 Colores
      const grisClaro = { argb: 'D9D9D9' }; // Gris claro
      const azulClaro = { argb: '1f4e78' }; // Azul celeste
      const azulOscuro = { argb: 'deeaf6' }; // Azul celeste

      // 🧱 Fila 1: Encabezados
      worksheet.getCell(`B${currentRow}`).value = ""; // ← Celda vacía arriba de "Nombre"
      worksheet.getCell(`C${currentRow}`).value = "Emitido por (nombre): ";
      worksheet.mergeCells(`D${currentRow}:G${currentRow}`);
      worksheet.getCell(`D${currentRow}`).value = "Revisado por (nombre):";
      worksheet.mergeCells(`H${currentRow}:I${currentRow}`);
      worksheet.getCell(`H${currentRow}`).value = "Aprobado por (Skretting): ";
      worksheet.mergeCells(`J${currentRow}:L${currentRow}`);
      worksheet.getCell(`J${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: grisClaro };
      worksheet.getCell(`J${currentRow}`).value = "Trabajo en Altura > 1,8 m"; // ← Texto agregado
      worksheet.getCell(`M${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: grisClaro };
      worksheet.getCell(`M${currentRow}`).value = "Acceso a techos (seguros e inseguros)"; // ← Texto agregado

      // Estilos y bordes fila 1
      ["B", "C", "D", "H"].forEach(col => {
        const cell = worksheet.getCell(`${col}${currentRow}`);
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      });
      // Mantener alineación para J y M pero sin negrita
      ["J", "M"].forEach(col => {
        const cell = worksheet.getCell(`${col}${currentRow}`);
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      });
      for (let col = 2; col <= 13; col++) {
        // 🔸 No aplicar bordes a celda B en esta fila
        if (col !== 2) {
          worksheet.getCell(currentRow, col).border = {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' }
          };
        }
      }
      currentRow++;

      // 🧱 Fila 2: Nombre y Firma
      worksheet.getCell(`B${currentRow}`).value = "Nombre:";
      worksheet.getCell(`B${currentRow}`).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      worksheet.getCell(`C${currentRow}`).value = "";
      worksheet.mergeCells(`D${currentRow}:G${currentRow}`);
      worksheet.mergeCells(`H${currentRow}:I${currentRow}`);
      worksheet.mergeCells(`J${currentRow}:L${currentRow}`);
      worksheet.getCell(`J${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: grisClaro };
      worksheet.getCell(`J${currentRow}`).value = "Trabajo en Caliente (ej. soldadura, oxicorte, esmerilado, etc.)"; // ← Texto agregado
      worksheet.getCell(`J${currentRow}`).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };


      // M columna combinada azul (desde fila "Nombre" hasta fila "Responsable de")
      worksheet.mergeCells(currentRow, 13, currentRow + 2, 13);
      worksheet.getCell(`M${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: azulClaro };
      worksheet.getCell(`M${currentRow}`).font = { color: { argb: 'FFFFFFFF' }, bold: true  }; // Texto blanco
      worksheet.getCell(`M${currentRow}`).value = "El supervisor de seguridad del contratista debe entrenar a su personal en las medidas de mitigación definidas en este documento."; // ← Texto agregado
      worksheet.getCell(`M${currentRow}`).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      // Bordes fila 2
      for (let col = 2; col <= 13; col++) {
        worksheet.getCell(currentRow, col).border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' }
        };
      }
      // Después de agregar fila 2 (Nombre):
      worksheet.getRow(currentRow).height = 40;
      currentRow++;

      // 🧱 Fila 3: Firma
      worksheet.getCell(`B${currentRow}`).value = "Firma:";
      worksheet.getCell(`B${currentRow}`).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      worksheet.getCell(`C${currentRow}`).value = "";
      // --- INSERTAR LA FIRMA DEL  COMPANY AQUÍ ---
      if (companyImageId !== null) {
        worksheet.addImage(companyImageId, {
          // Posicionar sobre la celda H y I (que están fusionadas en tu ejemplo)
          // Necesitarás ajustar las coordenadas para que se vea bien.
          // Esto es ensayo y error.
          // tl: Top-Left (columna, fila)
          // ext: Extensiones (ancho, alto en píxeles, o en unidades internas de exceljs)
          tl: { col: 2.99999999, row: currentRow -0.4 }, // Columna H es 7 (0-indexed). Fila actual -1 para subirla un poco
          ext: { width: 150, height: 85 } // Ajusta el ancho y alto de la imagen
          // Otra opción para posicionamiento es usar from/to si quieres que ocupe un rango de celdas exacto:
          // tl: { col: 7, row: currentRow - 1 }, // Columna H
          // br: { col: 9, row: currentRow } // Columna I
        });
      }

      worksheet.mergeCells(`D${currentRow}:G${currentRow}`);
      // --- INSERTAR LA FIRMA DEL GISIS AQUÍ ---
      if (gisisImageId !== null) {
        worksheet.addImage(gisisImageId, {
          // Posicionar sobre la celda H y I (que están fusionadas en tu ejemplo)
          // Necesitarás ajustar las coordenadas para que se vea bien.
          // Esto es ensayo y error.
          // tl: Top-Left (columna, fila)
          // ext: Extensiones (ancho, alto en píxeles, o en unidades internas de exceljs)
          tl: { col: 3.99999999, row: currentRow -0.4 }, // Columna H es 7 (0-indexed). Fila actual -1 para subirla un poco
          ext: { width: 150, height: 85 } // Ajusta el ancho y alto de la imagen
          // Otra opción para posicionamiento es usar from/to si quieres que ocupe un rango de celdas exacto:
          // tl: { col: 7, row: currentRow - 1 }, // Columna H
          // br: { col: 9, row: currentRow } // Columna I
        });
      }
      worksheet.mergeCells(`H${currentRow}:I${currentRow}`);
      // --- INSERTAR LA FIRMA DEL APROBADOR AQUÍ ---
      if (approverImageId !== null) {
        worksheet.addImage(approverImageId, {
          // Posicionar sobre la celda H y I (que están fusionadas en tu ejemplo)
          // Necesitarás ajustar las coordenadas para que se vea bien.
          // Esto es ensayo y error.
          // tl: Top-Left (columna, fila)
          // ext: Extensiones (ancho, alto en píxeles, o en unidades internas de exceljs)
          tl: { col: 7.99999999, row: currentRow -0.4 }, // Columna H es 7 (0-indexed). Fila actual -1 para subirla un poco
          ext: { width: 150, height: 85 } // Ajusta el ancho y alto de la imagen
          // Otra opción para posicionamiento es usar from/to si quieres que ocupe un rango de celdas exacto:
          // tl: { col: 7, row: currentRow - 1 }, // Columna H
          // br: { col: 9, row: currentRow } // Columna I
        });
      }
      worksheet.mergeCells(`J${currentRow}:L${currentRow}`);
      worksheet.getCell(`J${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: grisClaro };
      worksheet.getCell(`J${currentRow}`).value = "Espacio Confinado (ingreso a tanques, ollas, pasteurizador, lavadora, ejm.) "; // ← Texto agregado
      worksheet.getCell(`J${currentRow}`).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };

      // Bordes fila 3 (firma)
      for (let col = 2; col <= 13; col++) {
        worksheet.getCell(currentRow, col).border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' }
        };
      }

      // Después de agregar fila 3 (Firma):
      worksheet.getRow(currentRow).height = 100;
      currentRow++;

      // 🧱 Fila 3: Responsables
      worksheet.getCell(`B${currentRow}`).value = ""; // ← Celda vacía debajo de "Firma:"
      worksheet.getCell(`C${currentRow}`).value = "Responsable de Seguridad del contratista:";
      worksheet.getCell(`C${currentRow}`).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      worksheet.mergeCells(`D${currentRow}:G${currentRow}`);
      worksheet.getCell(`D${currentRow}`).value = "Contratante GISIS (ej: mantenimiento, proyectos, sanidad)";
      worksheet.getCell(`D${currentRow}`).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      worksheet.mergeCells(`H${currentRow}:I${currentRow}`);
      worksheet.getCell(`H${currentRow}`).value = "HSE GISIS";
      worksheet.getCell(`H${currentRow}`).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      worksheet.mergeCells(`J${currentRow}:L${currentRow}`);
      worksheet.getCell(`J${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: grisClaro };
      worksheet.getCell(`J${currentRow}`).value = "Trabajos de Izaje (uso de grúa, tecles, montacargas, poleas)"; // ← Texto agregado
      worksheet.getCell(`J${currentRow}`).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      // Estilos y bordes fila 4
      ["B", "C", "D", "H"].forEach(col => {
        const cell = worksheet.getCell(`${col}${currentRow}`);
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      });
      // Mantener alineación para J y M pero sin negrita
      ["J", "M"].forEach(col => {
        const cell = worksheet.getCell(`${col}${currentRow}`);
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      });
      // Bordes fila 4 (Responsables)
      for (let col = 2; col <= 13; col++) {
        // 🔸 No aplicar bordes a celda B en esta fila
        if (col !== 2) {
          worksheet.getCell(currentRow, col).border = {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' }
          };
        }
      }

      // Después de agregar fila 4 (Responsables):
      worksheet.getRow(currentRow).height = 40;
      currentRow++;

// 5️⃣ Texto centrado
      worksheet.getCell(`B${currentRow}`).value = "PERSONAL INVOLUCRADO EN EL TRABAJO";
      worksheet.getCell(`B${currentRow}`).font = { bold: true };
      currentRow++;

// 6️⃣ Título de la sección
      const socialText = "SE HA SOCIALIZADO EL CONTENIDO DE ESTE DOCUMENTO CON TODAS LAS PERSONAS INVOLUCRADAS QUE FIRMEN ESTE DOCUMENTO CONOCEN LOS RIESGOS ASOCIADOS A LAS ACTIVIDADES A REALIZAR.";
      worksheet.mergeCells(currentRow, 2, currentRow, 10); // B -> J
      worksheet.getCell(`B${currentRow}`).value = socialText;
      worksheet.getCell(`B${currentRow}`).alignment = { horizontal: 'center', wrapText: true };
      worksheet.getCell(`B${currentRow}`).font = { bold: false };
      currentRow += 2;

// 7️⃣ Encabezado tabla final
      worksheet.getCell(`C${currentRow}`).value = "NOMBRE Y APELLIDO";
      worksheet.getCell(`C${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: azulOscuro };
      worksheet.mergeCells(`C${currentRow}:G${currentRow}`);
      worksheet.getCell(`H${currentRow}`).value = "FIRMA";
      worksheet.getCell(`H${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: azulOscuro };
      worksheet.mergeCells(`H${currentRow}:I${currentRow}`);

// Estilo del encabezado
      ["C", "H"].forEach(col => {
        const cell = worksheet.getCell(`${col}${currentRow}`);
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });

// Bordes del encabezado
      ["C", "D", "E", "F", "G", "H", "I"].forEach(col => {
        worksheet.getCell(`${col}${currentRow}`).border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
      currentRow++;

// 🔁 Crear 6 bloques de firma (cada uno de 3 filas de alto)
      for (let i = 0; i < 6; i++) {
        const startRow = currentRow;
        const endRow = currentRow + 2;

        // Combinar celdas para "NOMBRE Y APELLIDO"
        worksheet.mergeCells(startRow, 3, endRow, 7); // C (3) → G (7)

        // Combinar celdas para "FIRMA"
        worksheet.mergeCells(startRow, 8, endRow, 9); // H (8) → I (9)

        // Estilo y bordes
        const blocks = [
          { col: 'C', cell: worksheet.getCell(`C${startRow}`) }, // Nombre
          { col: 'H', cell: worksheet.getCell(`H${startRow}`) }  // Firma
        ];

        blocks.forEach(({ col, cell }) => {
          cell.alignment = { vertical: 'middle' };
          const cols = col === 'C' ? ['C', 'D', 'E', 'F', 'G'] : ['H', 'I'];
          cols.forEach(c => {
            worksheet.getCell(`${c}${startRow}`).border = {
              top: { style: 'thin' },
              bottom: { style: 'thin' },
              left: { style: 'thin' },
              right: { style: 'thin' }
            };
          });
        });
        currentRow += 3; // Avanza 3 filas para el siguiente bloque
      }

      // 1️⃣ Generar y subir Excel sin QR
      const initialData = await workbook.xlsx.writeBuffer();
      const initialBlob = new Blob([initialData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const uploadForm = new FormData();
      uploadForm.append('FileUpload', initialBlob, filename);
      uploadForm.append('CompanyID', obj.CompanyId.toString());
      uploadForm.append('TaskRiskAnalysisId', obj.TaskRiskAnalysisId.toString());
      const creatorUserId = parseInt(this.userinfo.UserId, 10);
      uploadForm.append('CreatorUser', isNaN(creatorUserId) ? '0' : creatorUserId.toString());

      const res: any = await this.srv.LoadART(uploadForm).toPromise();

      // 2️⃣ Generar QR con la URL real
      const qrBase64 = await QRCode.toDataURL(res.url, { errorCorrectionLevel: 'H', margin: 1, scale: 5 });
      const qrImageBuffer = Uint8Array.from(atob(qrBase64.split(',')[1]), c => c.charCodeAt(0));
      const qrImageId = workbook.addImage({ buffer: qrImageBuffer, extension: 'png' });

      // 3️⃣ Insertar QR
      // Asumiendo que quieres posicionar el QR en columnas K-M (índices 10 a 12) y 16 filas de alto
      const lastUsedRow = worksheet.lastRow ? worksheet.lastRow.number : currentRow;
      const qrRow       = lastUsedRow + 2;

// Combinamos celdas como fondo visual (opcional)
      worksheet.mergeCells(`K${qrRow}:M${qrRow + 10}`);

// Insertamos el QR usando solo `tl` y `ext` (sin `br`)
      worksheet.addImage(qrImageId, {
        tl: { col: 10.9, row: qrRow - 0.2 }, // K = col 10, ajustado base 0
        ext: { width: 200, height: 200 } // ajusta según tamaño deseado
      });

      // 4️⃣ Regenerar y descargar UNA vez
      const finalData = await workbook.xlsx.writeBuffer();
      const finalBlob = new Blob([finalData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fs.saveAs(finalBlob, res.fileName || filename);

  }
  public async uploadDataBase(row: any) {
    debugger
    //console.log("datosfila:",row)
    var par_url = "EmployeeDocument/Update";
    var to: any;
    to = {};
    if (row.DocTypeWorker == true) { //documento por tipo de trabajo
      to.docuTypeID = row.TypeJob;//row.ParamDocumentID;
      to.ParamDocumentID = 0;
      to.DocumentId = row.ParamDocumentID;
    } else { //documento que NO es por tipo de trabajo
      to.ParamDocumentID = row.ParamDocumentID;
      //to.DocumentId=row.ParamDocumentID;
      //to.docuTypeID == 0;
    }

    to.EmployeeId = this.userinfo.employeeId;
    to.LastModifierUser = this.userinfo.logon;
    to.CreatorUser = this.userinfo.logon;
    to.FileName = this.namefile;
    to.DateDocument = row.date_doc;
    //to.TypeJob=row.TypeJob;
    try {
      const res = await this.srv.postCall(par_url, to).toPromise();
      if (res.success) {
        this.reload.next(true);
        this.closeModal('update5');
        Swal.fire(this.translations.msg_update, res.msg, 'success');
        this.archivos = [];
        this.getList();
      } else {
        Swal.fire('Error', res.msg, 'error');
      }
    } catch (err) {
      Swal.close();
      Swal.fire('Error');
    }

  }


  public async getApproversOld() {
    const url = API_USER_APPROVERS_GET_ALL;

    this.srv.getCall(url).subscribe(x => {
      if (x.success) {
        if (x.val != null) {
          this.list_pprovers = x.val;

          console.log('Lista de aprobadores:', this.list_pprovers);
          const userIdLogged = parseInt(this.userinfo.userId);
          this.isApproved = this.list_pprovers.some(
            ap => {
              if (ap.UserIdAquasym === userIdLogged && ap.PlantaId === Number(this.currentPlanta)) {
                this.UserId = ap.UserId;
                this.countApprovers=ap.length;
                return true;
              }
              return false;
            }
          );
        } else {
          this.list_pprovers = [];
        }
      } else {
        this.list_pprovers = [];
      }
      console.log('aprovador', this.isApproved)
      console.log('userid', this.UserId)
      console.log('countApprovers', this.countApprovers)
    });
  }

}
